<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/divergencias" back-text="Hab/Div">
            <ai-analysis-button
                v-if="dataset.data && dataset.data.id"
                :endpoint="`/api/admin/ai/hab-div/${dataset.data.id}/analyze`"
                label="Analisar com IA"
                title="Análise IA da Hab/Div"
            />
            <v-btn
                v-if="dataset.data && dataset.data.id"
                type="button"
                depressed
                color="primary"
                outlined
                :loading="documentsDownloadLoading"
                :disabled="documentsCount === 0"
                @click="downloadDocuments"
            >
                <v-icon left small>mdi-folder-zip-outline</v-icon>
                Baixar documentos
            </v-btn>
        </ui-page-header>

        <!-- <v-row v-if="dataset.data.status == 0">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>


                    Esta {{ dataset.data.user.uuid_ref ? 'divergência' : 'habilitação' }} ainda não foi analisada

                </v-banner>
            </v-col>
        </v-row> -->

        <!-- Pedido retardatario (art. 10 da LRF): credito aprovado vai ao Edital do art. 7o com a marca -->
        <div v-if="dataset.data && dataset.data.id" class="late-filing-bar mb-4">
            <v-switch :input-value="Number(dataset.data.late_filing) === 1" :loading="lateFilingSaving"
                :disabled="lateFilingSaving || !$check('Event', 'PATCH')" label="Pedido retardatário"
                color="warning" inset dense hide-details class="mt-0 pt-0" @change="updateLateFiling" />
            <span class="caption ui-muted">
                Incluído depois do prazo de habilitações e divergências. Se aprovado, o crédito entra no Edital do art. 7º
                com a origem marcada como retardatária.
            </span>
        </div>

        <div v-if="dataset.data && dataset.data.procuration && Number(dataset.data.procuration.status) !== 1" class="mb-4">
                <v-alert :type="Number(dataset.data.procuration.status) === 2 ? 'error' : 'warning'" text dense class="mb-0">
                    <strong>Procuração {{ ({ 2: 'rejeitada', 3: 'com regularização solicitada' })[Number(dataset.data.procuration.status)] || 'pendente de análise' }}.</strong>
                    Este pedido foi apresentado pelo procurador
                    <strong>{{ dataset.data.procuration.procurator_name || 'não identificado' }}</strong>
                    em caráter provisório. A apreciação fica condicionada à regularidade da representação.
                    <v-btn v-if="dataset.data.procuration.procurator_user_id" small text color="primary" class="ml-2"
                        :to="`/procuradores/${dataset.data.procuration.procurator_user_id}`">
                        Ver procurador
                    </v-btn>
                </v-alert>
        </div>

        <div
            v-if="dataset.data.currentReview && dataset.data.currentReview.status == 0" class="mb-4">
                <v-banner single-line outlined icon="mdi-alert-outline">

                    Este pedido está em revisão. Por favor, realize a análise e finalize o processo.

                </v-banner>
        </div>

        <div v-if="dataset.data && dataset.data.status == 4" class="mb-4">
                <v-banner single-line outlined>
                   
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>

                    Pedido aguardando documentos solicitados. Prazo até {{
                   $moment(dataset.data.requested_doc_at).add(72, 'hours').toDate() |
                   defaultDate('DD/MM/YYYY [às] HH:mm')
               }}

                </v-banner>
        </div>

        <div
            v-if="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6" class="mb-4">
                <v-banner single-line outlined>

                    <div class="d-flex justify-space-between align-center">
                        <div>
                            Esta divergência foi marcada como <span> <strong>{{
                                dataset.data.status === 1
                                    ? 'aprovada'
                                    : (dataset.data.status === 2
                                        ? 'rejeitada'
                                        : (dataset.data.status === 3
                                            ? 'aprovada parcialmente'
                                            : ''
                                        )
                                    )
                            }}</strong>

                            </span> por
                            <span> <strong>
                                    {{
                                        dataset.data.admin
                                            ? dataset.data.admin.name
                                            : dataset.data.analyzed_at !== "0000-00-00 00:00:00" && !dataset.data.admin
                                                ? "SISTEMA"
                                                : "N/A"
                                    }}
                                </strong></span>

                        </div>

                        <!-- <div class="icon-container">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon icon v-on="on" @click="statusReset()" size="large" class="border ">
                                        mdi-reload
                                    </v-icon>
                                </template>
                        <span>Restaurar pedido</span>
                        </v-tooltip>
                        </div> -->
                    </div>
                </v-banner>
        </div>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm" v-if="dataset.data && dataset.data.user">
                            <ui-section title="Detalhes credor">
                                <template #actions>
                                    <v-btn small outlined color="primary" @click="openPortabilityDialog">
                                        <v-icon left small>mdi-account-switch-outline</v-icon>
                                        Portabilizar pedido
                                    </v-btn>
                                </template>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled id="name" label="Nome completo"
                                                v-model="dataset.data.user.name" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="E-mail" v-model="dataset.data.user.email"
                                                required outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense disabled label="CPF/CNPJ"
                                                v-model="dataset.data.user.registration" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense id="phone" label="Telefone"
                                                v-model="dataset.data.user.phone_number" outlined hide-details="auto" disabled>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="dataset.data.contact_email || dataset.data.contact_name || dataset.data.contact_registration">
                                        <v-col cols="12">
                                            <v-alert dense text type="info" class="mb-0">
                                                <strong>Contato do pedido:</strong>
                                                <span>{{ dataset.data.contact_name || dataset.data.user.name }}</span>
                                                <span v-if="dataset.data.contact_email"> - {{ dataset.data.contact_email }}</span>
                                                <span v-if="dataset.data.contact_registration"> - {{ formatRegistrationValue(dataset.data.contact_registration) }}</span>
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-4" dense v-if="dataset && dataset.data && dataset.data.user.url_document">
                                        <!-- <v-col cols="2" sm="4" md="3" class="mr-5"
                                            v-if="dataset && dataset.data && dataset.data.user && dataset.data.user.url_document">
                                            <div class="document-container">
                                                <a :href="dataset.data.user.url_document" target="_blank"
                                                    rel="noopener noreferrer" class="overlay-link">
                                                </a>
                                                <iframe :src="dataset.data.user.url_document"
                                                    class="document-frame rounded-xl"></iframe>
                                            </div>
                                            <div class="text-left caption-text">DOCUMENTO CREDOR</div>
                                        </v-col>
                                         -->
                                        
                                        <v-col cols="12">
                                            <v-row justify="start">
                                                <v-col cols="12" sm="8" md="5" lg="4" class="text-center">
                                                <!-- So PDF vai para a moldura: outro formato seria baixado sozinho ao abrir a pagina -->
                                                <div v-if="creditorDocumentKind !== 'other'" class="document-container" style="position: relative; display: inline-block;">
                                                    
                                                    <a
                                                    :href="dataset.data.user.url_document"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 2;"
                                                    ></a>

                                                    <div class="iframe-wrapper">
                                                    <iframe
                                                        v-if="creditorDocumentKind === 'pdf'"
                                                        :src="dataset.data.user.url_document"
                                                        class="document-frame rounded-xl"
                                                        style="width: 100%; height: 400px; border: 1px solid #ccc; border-radius: 12px;"
                                                    ></iframe>
                                                    <img
                                                        v-else
                                                        :src="dataset.data.user.url_document"
                                                        alt="Documento do credor"
                                                        class="document-frame rounded-xl"
                                                        style="width: 100%; max-height: 400px; object-fit: contain; border: 1px solid #ccc; border-radius: 12px;"
                                                    />
                                                    </div>
                                                </div>

                                                <v-alert v-if="creditorDocumentKind === 'other'" dense text type="warning" class="text-left mb-0">
                                                    O documento do credor foi enviado em um formato que não pode ser exibido aqui
                                                    ({{ creditorDocumentTypeLabel }}).
                                                    <div class="mt-2">
                                                        <v-btn small outlined color="primary" :href="dataset.data.user.url_document"
                                                            target="_blank" rel="noopener noreferrer">
                                                            <v-icon left small>mdi-download</v-icon> Baixar documento
                                                        </v-btn>
                                                    </div>
                                                </v-alert>
                                                <div class="caption-text mt-3">Documento do credor</div>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                    </v-row>
                            </ui-section>

                            <!-- Credito arrolado no Edital do art. 52 para o CPF/CNPJ do pedido -->
                            <ui-section title="Crédito no Edital do art. 52">
                                <template #actions>
                                    <ui-badge :text="editalCredits.length ? 'Arrolado' : 'Não arrolado'" :color="editalCredits.length ? 'success' : 'grey'" />
                                </template>
                                    <template v-if="editalCredits.length">
                                        <div class="text-caption ui-muted mb-2">
                                            Crédito(s) arrolado(s) para o CPF/CNPJ {{ dataset.data.user ? dataset.data.user.registration : dataset.data.contact_registration }}
                                            na primeira lista de credores do caso (Edital do art. 52 da Lei nº 11.101/2005).
                                        </div>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Classificação</th>
                                                    <th class="text-right">Valor arrolado</th>
                                                    <th class="text-left">Devedora</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="credit in editalCredits" :key="credit.id">
                                                    <td>{{ credit.class_name }}</td>
                                                    <td class="text-right">
                                                        {{ credit.currency | enum(dataset.currencyTypes, 'id', 'currencyFormat') }} {{ credit.amount | currency }}
                                                    </td>
                                                    <td>{{ credit.company_name || '-' }}</td>
                                                </tr>
                                                <tr v-if="editalCredits.length > 1" class="font-weight-bold">
                                                    <td>Total</td>
                                                    <td class="text-right">R$ {{ editalTotal | currency }}</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </template>
                                    <v-alert v-else dense text type="info" class="mb-0">
                                        Não há crédito arrolado para este CPF/CNPJ no Edital do art. 52 deste caso.
                                    </v-alert>
                            </ui-section>
        </v-form>

        <!-- <v-row v-if="dataset.data && dataset.data.user">
            <v-col>
                <v-card outlined>
                    <v-card-text>
                        <v-row class="align-center">
                            <v-col cols="12" sm="6" class="d-flex align-center mt-n5">
                                <v-checkbox v-model="dataset.data.review_later" label="Sinalizar pedido" hide-details
                                    @change="saveReviewLater"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select dense :items="dataset.qgcRuleTypes" label="Regra"
                                    v-model="dataset.data.user_creditor_rule" item-value="id" item-text="name" outlined
                                    @change="saveSelectedRule" hide-details="auto"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <!-- <v-row v-if="dataset.data.status == 0">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Ações</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="accent" class="mr-5"
                                    @click="updateStatus('approve')">Aprovar</v-btn>

                                <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="indigo darken-1" class="mr-5 white--text"
                                    @click="updateStatus('partial')">Aprovar Parcialmente</v-btn>

                                <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="error"
                                    @click="updateStatus('reject')">Rejeitar</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

                        <ui-section title="Contraditórios" class="mt-4">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense type="date" label="Prazo contraditório"
                                            :value="formatDate(dataset.data.contradictory_deadline_at)"
                                            @input="updateContraditory" outlined hide-details="auto">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-btn v-if="$allowed('save')" :loading="dataset.loading" type="button" elevation="0" color="primary"
                                            @click="updateContradictoryDeadline()">Salvar</v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider class="my-4"></v-divider>
                                <template v-if="dataset.data.contradictory_status || dataset.data.contradictory_reason">
                                    
                                    <div v-if="dataset.data.contradictory_status" class="mb-4">
                                        <span class="font-weight-bold mr-2">Status:</span>
                                        <ui-badge :text="getContradictoryText(dataset.data.contradictory_status)"
                                            :tone="getContradictoryTone(dataset.data.contradictory_status)" />
                                    </div>

                                    <div v-if="dataset.data.contradictory_status == 2 && dataset.data.contradictory_amount" class="mb-4">
                                        <span class="font-weight-bold mr-2">Valor Aprovado Parcialmente:</span>
                                        <span>R$ {{ dataset.data.contradictory_amount }}</span>
                                    </div>

                                    <div v-if="dataset.data.contradictory_reason">
                                        <span class="font-weight-bold">Motivo/Descrição:</span>
                                        <div class="mt-2" v-html="dataset.data.contradictory_reason"></div>
                                    </div>
                                    
                                </template>
                                
                                <span v-else class="ui-muted">Nenhum contraditório encontrado</span>

                                <!-- Documentos enviados pela devedora no contraditorio -->
                                <div v-if="contradictoryFiles.length" class="mt-4">
                                    <div class="font-weight-bold mb-2">Documentos ({{ contradictoryFiles.length }})</div>
                                    <div class="d-flex flex-wrap" style="gap: 8px;">
                                        <v-btn v-for="doc in contradictoryFiles" :key="doc.id" type="button" color="primary" outlined small
                                            :href="doc.url" target="_blank" rel="noopener noreferrer" :title="doc.name">
                                            <v-icon left small>{{ (doc.mime_type || doc.name || '').toLowerCase().includes('pdf') ? 'mdi-file-pdf-box' : 'mdi-file-outline' }}</v-icon>
                                            <span class="contradictory-doc-name">{{ doc.name }}</span>
                                        </v-btn>
                                    </div>
                                </div>
                        </ui-section>

                <ui-section title="Processos">
                        <template v-if="dataset.data && dataset.data.processes && dataset.data.processes.length > 0">
                            <v-expansion-panels>
                                <v-expansion-panel v-for="(process) in dataset.data.processes" :key="process.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Número: </strong>
                                            <span class="ml-2 mr-2">
                                                {{ process.number }}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <v-icon @click="copyToClipboard(process.number)"
                                                >mdi-content-copy</v-icon>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <p><strong>Local:</strong> {{ process.local }}</p>
                                        <p><strong>Tribunal:</strong> {{ process.court }}</p>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                        <template v-else>
                            <v-row>
                                <v-col>
                                    <span class="ui-muted">Nenhum processo encontrado</span>
                                </v-col>
                            </v-row>
                        </template>
                </ui-section>

                <ui-section v-if="dataset.data.currentReview" title="Revisão">
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Resultado: </strong> <span>{{ dataset.data.currentReview.status |
                                            enum(dataset.eventStatus, 'id', 'name') }}</span>
                                        <br />
                                        <strong>Revisado em: </strong>
                                        <span v-if="dataset.data.currentReview.reviewed_at">{{
                                            dataset.data.currentReview.reviewed_at | defaultDate('DD/MM/YYYY')
                                            }}</span>
                                        <span v-else>N/A</span>
                                        <br />
                                        <strong>Revisado por: </strong>
                                        <span>{{
                                            dataset.data.currentReview.reviewed_by ?
                                                dataset.data.currentReview.admin.name :
                                                'N/A'
                                        }}</span>
                                        <br />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                </ui-section>

                <ui-section title="Negócios">
                    <template #actions>
                        <div style="width: 200px;">
                            <v-progress-linear :value="dataset.loading ? undefined : progress"
                                color="success" height="22" rounded :indeterminate="dataset.loading"
                                background-opacity="0.15">
                                <span class="text-caption font-weight-medium white--text" v-if="!dataset.loading">{{ progress }}% analisados</span>
                                <span class="text-caption" v-else>Carregando...</span>
                            </v-progress-linear>
                        </div>
                    </template>
                        <v-row class="mb-2">
                            <v-col cols="12" sm="4">
                                <div class="text-caption ui-muted">Tipo</div>
                                <div class="font-weight-medium">Habilitação/Divergência</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text-caption ui-muted">Devedora</div>
                                <div class="font-weight-medium">{{ getEventDebtorSummary() }}</div>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <div class="text-caption ui-muted">Solicitado em</div>
                                <div class="font-weight-medium">{{ dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}</div>
                            </v-col>
                        </v-row>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col>
                                        <!--
                                        <v-row>
                                            <v-col cols="3">
                                                <strong>Total de casos analisados: </strong>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-progress-linear :value="progress" color="green" height="20"
                                                    class="mb-3" rounded>
                                                    <strong>{{ progress }}%</strong>
                                                </v-progress-linear>
                                            </v-col>
                                        </v-row>
                                        --->

                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading" class="mb-2">
                                    <v-col class="d-flex align-center">
                                        <span class="text-caption ui-muted mr-2">Resultado:</span>
                                        <ui-badge :tone="getStatusTone(getFinalStatus())">{{ getFinalStatus() | enum(dataset.eventStatus, 'id', 'name') }}</ui-badge>
                                    </v-col>
                                </v-row>
                                <v-row v-if="!dataset.loading" class="mb-2">
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="dataset.data.credit_exclusion"
                                            class="mt-0"
                                            dense
                                            hide-details="auto"
                                            :true-value="1"
                                            :false-value="0"
                                            :disabled="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6"
                                            label="Exclusão do crédito no Edital 7">
                                        </v-checkbox>
                                        <div class="text-caption ui-muted">
                                            Quando marcado, todo este pedido permanece no QGC com valor zerado.
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="!dataset.loading && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                    <v-col class="d-flex flex-wrap" style="gap: 8px;">
                                        <v-btn type="button" elevation="0" outlined color="grey" small v-if="(dataset.data.status && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6) && $allowed('event.archive')"
                                            @click="statusReset()">
                                            <v-icon left x-small>mdi-restore</v-icon>Restaurar</v-btn>

                                        <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="success" small dark
                                            :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6) || !getFinalStatus()"
                                            @click="updateStatus()">
                                            <v-icon left x-small>mdi-check</v-icon>Confirmar</v-btn>

                                        <v-btn v-if="$allowed('event.review')" type="button" elevation="0" outlined color="warning" small :disabled="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6"
                                            @click="createReview()">
                                            <v-icon left x-small>mdi-send</v-icon>Enviar para revisão</v-btn>

                                        <v-btn type="button" elevation="0" outlined color="primary" small
                                            :disabled="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6"
                                            @click.stop="openRequestDoc()">
                                            <v-icon left x-small>mdi-file-document-outline</v-icon>Solicitar Documento</v-btn>

                                        <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="primary" small
                                            :disabled="dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6"
                                            @click.stop="openCreateBusinessModal()">Adicionar
                                            Negócio</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading && dataset.data.currentReview && dataset.data.currentReview.status == 0">
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-if="$allowed('edit')" v-on="on" type="button" elevation="0" color="accent" class="mr-5"
                                                    small @click="updateReview(1)">Aprovar</v-btn>
                                            </template>
                                            <span>Clique no botão para aprovar a revisão</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="error" class="mr-5"
                                                    small @click="updateReview(2)">Rejeitar</v-btn>
                                            </template>
                                            <span>Clique no botão para rejeitar a revisão</span>
                                        </v-tooltip>

                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <div>
                                            <div v-if="dataset.loading" class="loading-container">
                                                <v-progress-circular indeterminate color="green" size="50"
                                                    class="my-5"></v-progress-circular>
                                                <span>Carregando...</span>
                                            </div>
                                            <v-expansion-panels v-else>

                                                <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                    :key="eventIndex">

                                                    <!-- <div
                                                        :class="eventItem.isChecked ? 'checkbox-marked-wrapper' : 'checkbox-wrapper'">
                                                        <v-checkbox v-model="eventItem.isChecked" class="ml-3"
                                                            color="green"
                                                            @change="toggleCheckbox(eventItem)"></v-checkbox>
                                                    </div> -->

                                                    <v-expansion-panel-header @click.stop>
                                                        <div class="d-flex align-center">
                                                            <div>
                                                                <strong>ID: </strong>
                                                                <span class="ml-2 mr-2">#{{ eventItem.id }}</span> /
                                                                <strong>Origem: </strong>
                                                                <span class="ml-2 mr-2">{{ truncateText(eventItem.origin
                                                                    ||
                                                                    'N/A', 30) }}</span> /
                                                                <strong class="ml-2">Valor: </strong>
                                                                <span class="ml-2" v-if="eventItem.amount">
                                                                    {{ eventItem.currency | enum(dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat') }}
                                                                    {{ eventItem.amount | currency }}
                                                                </span>
                                                                <span v-else>N/A</span>
                                                                <template v-if="getItemDebtorName(eventItem)">
                                                                    /
                                                                    <strong class="ml-2">Devedora: </strong>
                                                                    <span class="ml-2">
                                                                        {{ truncateText(getItemDebtorName(eventItem), 30) }}
                                                                    </span>
                                                                </template>
                                                            </div>

                                                            <v-spacer></v-spacer>

                                                            <ui-badge class="mr-10" :tone="getStatusTone(eventItem.status)">{{ eventItem.status | enum(dataset.eventStatus, 'id', 'name') }}</ui-badge>

                                                            <template
                                                                v-if="!eventItem.isEditing && (dataset.data.status == 0 || dataset.data.status == 4 || dataset.data.status == 5) && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                                                <v-tooltip bottom :disabled="!eventItem.status">
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 0)"
                                                                            :disabled="eventItem.status === 0 || eventItem.status === 4 || eventItem.status === 5"
                                                                            size="large">
                                                                            <v-icon>mdi-refresh-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Restaurar o status deste negócio</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, eventItem.partial_amount ? 3 : 1)"
                                                                            size="large" :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4"
                                                                            :color="eventItem.partial_amount ? 'warning' : 'green'">
                                                                            <v-icon>mdi-check-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span v-if="!eventItem.partial_amount">
                                                                        Aprovar este negócio
                                                                    </span>
                                                                    <span v-else>
                                                                        Aprovar parcialmente este negócio
                                                                    </span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="changeStatusEventItem(eventItem, 2)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4"
                                                                            size="large" color="red">
                                                                            <v-icon>mdi-close-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Rejeitar este negócio</span>
                                                                </v-tooltip>

                                                                <v-tooltip bottom>
                                                                    <template #activator="{ on }">
                                                                        <v-btn icon v-on="on"
                                                                            @click.stop="editItem(eventItem, eventIndex)"
                                                                            :disabled="eventItem.status !== 0 && eventItem.status !== 5 && eventItem.status !== 4"
                                                                            size="large" color="primary" class="me-2">
                                                                            <v-icon>mdi-pencil-circle</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Editar as informações deste negócio</span>
                                                                </v-tooltip>
                                                            </template>

                                                            <div v-if="eventItem.isEditing"
                                                                class="button-group ml-auto mr-10">
                                                                <v-btn v-if="$allowed('save')"
                                                                    @click.stop="saveEdit(eventItem)" small
                                                                    elevation="0" color="primary">
                                                                    Salvar
                                                                </v-btn>
                                                                <v-btn @click.stop="cancelEditItem(eventItem)" small
                                                                    elevation="0" color="error">
                                                                    Cancelar
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </v-expansion-panel-header>

                                                    <v-expansion-panel-content>
                                                        <v-row>
                                                            <v-col>
                                                                <p>
                                                                    <span class="section-info-title">Devedora</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-autocomplete dense
                                                                                    :items="getDebtorCompanyOptions(eventItem.company_name)"
                                                                                    v-model="eventItem.company_name"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto"
                                                                                    required :rules="[$rules.required]"
                                                                                    no-data-text="Nenhuma devedora encontrada"></v-autocomplete>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                            <span class="section-info-value">
                                                                            {{ getItemDebtorName(eventItem) }}
                                                                        </span>
                                                                    </template>
                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title">Origem</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-text-field :disabled="dataset.loading" dense label="Origem do negócio"
                                                                                   v-model="editedOrigin" required :rules="[$rules.required]" outlined
                                                                                    hide-details="auto" id="origin" >
                                                                                </v-text-field>
                                                                            </v-col>
                                                                            <!-- <v-col cols="3">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="origin"
                                                                                    :items="dataset.creditorOriginTypes"
                                                                                    label="Selecione a origem"
                                                                                    v-model="eventItem.origin"
                                                                                    item-value="name" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col> -->
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value">
                                                                            {{ eventItem.origin }}</span>
                                                                    </template>
                                                                </p>

                                                                <v-row>
                                                                    <v-col cols="3">
                                                                        <span class="section-info-title">Classe</span>
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-autocomplete dense
                                                                                :items="dataset.creditorTypes"
                                                                                v-model="eventItem.type" item-value="id"
                                                                                item-text="name" outlined
                                                                                hide-details="auto" required
                                                                                :rules="[$rules.required]"
                                                                                no-data-text="Nenhuma classe encontrada"
                                                                                @change="onAutocompleteChange(eventIndex)"
                                                                                ></v-autocomplete>
                                                                        </template>
                                                                        <template v-else>
                                                                            <br />
                                                                            <span
                                                                                class="section-info-value">
                                                                                {{
                                                                                    getCreditorTypeName(eventItem.type)
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </v-col>
                                                                </v-row>

                                                                <br />
                                                                <p>
                                                                    <span class="section-info-title">Moeda</span>
                                                                    <br />
                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="3">
                                                                                <v-select :disabled="dataset.loading"
                                                                                    dense id="type"
                                                                                    :items="dataset.currencyTypes"
                                                                                    label="Selecione uma moeda"
                                                                                    v-model="eventItem.currency"
                                                                                    item-value="id" item-text="name"
                                                                                    outlined hide-details="auto">
                                                                                </v-select>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="section-info-value">
                                                                            {{
                                                                                eventItem.currency
                                                                                | enum(
                                                                                    dataset.currencyTypes,
                                                                                    'id',
                                                                                    'name'
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </template>
                                                                </p>

                                                                <template>
                                                                    <p>
                                                                        <span class="section-info-title">Valor indicado
                                                                            pelo credor</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="3">
                                                                                    <v-currency-field
                                                                                        :disabled="dataset.loading"
                                                                                        label="Valor" dense
                                                                                        aria-label="Digite o valor do pedido"
                                                                                        v-model="editedAmount"
                                                                                        :allowNegative="false"
                                                                                        hide-details="auto" outlined
                                                                                        @input="validatePartialAmount(eventItem)">
                                                                                    </v-currency-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <div class="text-caption ui-muted mt-1">
                                                                                Corrige o valor do pedido (o que vai para o RVC). A alteração fica registrada no histórico.
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                    enum(dataset.currencyTypes, 'id',
                                                                                        'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.amount | currency }}
                                                                            </span>
                                                                        </template>
                                                                    </p>
                                                                    <p>
                                                                        <span class="section-info-title">Valor definido
                                                                            pelo
                                                                            AJ</span>
                                                                        <br />
                                                                        <template v-if="eventItem.isEditing">
                                                                            <v-row>
                                                                                <v-col cols="3">
                                                                                    <v-currency-field
                                                                                        :disabled="dataset.loading"
                                                                                        label="Valor" dense
                                                                                        aria-label="Digite o valor"
                                                                                        v-model="editedPartialAmount"
                                                                                        :allowNegative="false"
                                                                                        hide-details="auto" outlined
                                                                                        @input="validatePartialAmount(eventItem)">
                                                                                    </v-currency-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <div v-if="partialAmountError" class="text-caption red--text mt-1">{{ partialAmountError }}</div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span
                                                                                class="section-info-value">
                                                                                {{
                                                                                    eventItem.currency |
                                                                                    enum(dataset.currencyTypes, 'id',
                                                                                        'currencyFormat')
                                                                                }}
                                                                                {{ eventItem.partial_amount | currency
                                                                                }}
                                                                            </span>
                                                                        </template>
                                                                    </p>

                                                                </template>

                                                                <p>
                                                                    <span class="section-info-title">Créditos adicionais</span>
                                                                    <br />

                                                                    <template v-if="eventItem.credits && eventItem.credits.length">
                                                                        <v-simple-table dense class="additional-credits-table mt-1">
                                                                            <template #default>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Classe</th>
                                                                                        <th class="text-right">Valor</th>
                                                                                        <th>Moeda</th>
                                                                                        <th>Descrição</th>
                                                                                        <th class="text-right">Ações</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="credit in eventItem.credits" :key="credit.id">
                                                                                        <td>{{ getCreditorTypeName(credit.type) }}</td>
                                                                                        <td class="text-right">{{ credit.amount | currency }}</td>
                                                                                        <td>{{ credit.currency | enum(dataset.currencyTypes, 'id', 'name') }}</td>
                                                                                        <td>{{ credit.description || '—' }}</td>
                                                                                        <td class="text-right">
                                                                                            <v-btn icon small @click="openItemCreditDialog(eventItem, credit)">
                                                                                                <v-icon small>mdi-pencil-outline</v-icon>
                                                                                            </v-btn>
                                                                                            <v-btn icon small @click="confirmItemCreditDeletion(eventItem, credit)">
                                                                                                <v-icon small color="error">mdi-delete-outline</v-icon>
                                                                                            </v-btn>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </template>
                                                                        </v-simple-table>
                                                                    </template>
                                                                    <span v-else class="section-info-value">
                                                                        Não há créditos adicionais registrados
                                                                    </span>

                                                                    <br />
                                                                    <v-btn v-if="$allowed('create')" small outlined color="primary" class="mt-2"
                                                                        @click="openItemCreditDialog(eventItem)">
                                                                        <v-icon left small>mdi-plus</v-icon>
                                                                        Adicionar classe/valor
                                                                    </v-btn>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Observações</span>
                                                                    <br />
                                                                    <span class="section-info-value">
                                                                        {{ eventItem.observation ?
                                                                            eventItem.observation
                                                                            : 'Não há observações registradas' }}</span>
                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Motivo</span>
                                                                    <br />

                                                                    <template v-if="eventItem.isEditing">
                                                                        <v-row>
                                                                            <v-col cols="12">
                                                                                <ui-document-editor ref="itemReasonEditor" v-model="editedReason" orientation="landscape"
                                                                                    :min-height="120" :max-height="360" no-fullscreen placeholder="Motivo deste negócio">
                                                                                    <template #toolbar>
                                                                                        <button type="button" class="doc-toolbar__btn doc-toolbar__btn--text" title="Selecionar textos longos predefinidos"
                                                                                            @mousedown.prevent @click="openDialogDynamicText('editedReason')">
                                                                                            <v-icon size="18">mdi-text-long</v-icon><span>Textos automáticos</span>
                                                                                        </button>
                                                                                    </template>
                                                                                </ui-document-editor>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="!eventItem.reason"
                                                                            class="section-info-value">
                                                                            Não há motivos registrados
                                                                        </span>
                                                                        <div v-else v-html="eventItem.reason"></div>
                                                                    </template>

                                                                </p>
                                                                <p>
                                                                    <span class="section-info-title"
                                                                        color="red">Contraditório</span>
                                                                    <br />

                                                                    <template v-if="eventItem.contradictory_reason">
                                                                        <ui-badge class="mr-10 mt-4" :tone="getStatusTone(eventItem.contradictory_status)">{{ eventItem.contradictory_status | enum(dataset.eventStatus, 'id', 'name') }}</ui-badge>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Valor indicado: </strong>
                                                                        <span v-if="eventItem.contradictory_amount">
                                                                            {{ eventItem.contradictory_amount |
                                                                                currency }}
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Documentos: </strong>
                                                                        <template v-if="eventItem.contradictory_docs">
                                                                            <br />
                                                                            <span
                                                                                v-for="(item, index) in resolveContradictoryDocs()"
                                                                                :key="index">
                                                                                - <a :href="item">{{ item }}</a><br />
                                                                            </span>
                                                                        </template>
                                                                        <span v-else>N/A</span>
                                                                        <br />
                                                                        <br />
                                                                        <strong>Motivo </strong>
                                                                        <br />
                                                                        <div v-html="eventItem.contradictory_reason">
                                                                        </div>
                                                                    </template>

                                                                </p>

                                                                <p>
                                                                    <span class="section-info-title">Documentos</span>
                                                                    <br />
                                                                    <span class="section-info-value">{{
                                                                        eventItem.docs.length
                                                                        }}
                                                                        arquivo(s)</span>
                                                                    <br />
                                                                    <v-btn v-if="$allowed('edit')" class="mt-3" small outlined color="primary"
                                                                        @click="openEditDocumentsDialog(eventItem)">
                                                                        <v-icon left small>mdi-file-document-edit-outline</v-icon>
                                                                        Editar documentos
                                                                    </v-btn>
                                                                </p>
                                                               
                                                                <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                                <br>
                                                                <v-row
                                                                    v-for="category in getEventItemsByCategory(eventItem)"
                                                                    :key="category.id">
                                                                    <v-col cols="12">
                                                                        <h3>{{ category.name }}</h3>
                                                                        <br>
                                                                        <v-row>
                                                                            <v-col v-for="doc in category.docs"
                                                                                :key="doc.id" cols="auto">
                                                                                <v-img @click="openDoc(doc.file_url)"
                                                                                    :class="['rounded-xl', verifyIsRequestedDoc(doc) ? 'doc-active-class' : 'doc-inactive-class']"
                                                                                    lazy-src="https://picsum.photos/id/11/10/6"
                                                                                    :height="100" :width="100"
                                                                                    :src="doc.file_url">
                                                                                </v-img>
                                                                                {{ doc.name }}
                                                                                <br>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-col>
                                </v-row>
                </ui-section>

                <ui-section title="Honorários" description="Valores de honorários vinculados ao pedido ou a um negócio específico">
                    <template #actions>
                        <v-btn v-if="$allowed('create')" small outlined color="primary" @click="addAttorneyFee">
                            <v-icon left small>mdi-plus</v-icon>
                            Adicionar honorário
                        </v-btn>
                    </template>
                        <v-alert v-if="!dataset.attorneyFees.length" type="info" outlined dense>
                            Nenhum honorário cadastrado.
                        </v-alert>

                        <div
                            v-for="(fee, index) in dataset.attorneyFees"
                            :key="fee.localId || fee.id || index"
                            class="attorney-fee-row"
                        >
                            <v-row dense>
                                <v-col cols="12" md="3">
                                    <v-select
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="Aplicação"
                                        :items="attorneyFeeScopes"
                                        item-value="id"
                                        item-text="name"
                                        v-model="fee.scope"
                                        @change="onAttorneyFeeScopeChange(fee)"
                                    />
                                </v-col>
                                <v-col cols="12" md="5" v-if="fee.scope === 'item'">
                                    <v-autocomplete
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="Negócio"
                                        :items="attorneyFeeItemOptions"
                                        item-value="id"
                                        item-text="name"
                                        v-model="fee.user_event_item_id"
                                    />
                                </v-col>
                                <v-col cols="12" :md="fee.scope === 'item' ? 4 : 9">
                                    <v-autocomplete
                                        dense
                                        outlined
                                        clearable
                                        hide-details="auto"
                                        label="Procurador"
                                        :items="dataset.procurators"
                                        :loading="dataset.procuratorsLoading"
                                        item-value="id"
                                        :item-text="formatAttorneyFeeProcurator"
                                        v-model="fee.procurator_user_id"
                                        @change="onAttorneyFeeProcuratorChange(fee)"
                                    >
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ formatRegistrationValue(item.registration) }}
                                                    <span v-if="item.oab"> - OAB {{ item.oab }}{{ item.oab_state ? `/${item.oab_state}` : '' }}</span>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.name }} - {{ formatRegistrationValue(item.registration) }}</span>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Nenhum procurador encontrado
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-btn v-if="$allowed('create')" small color="primary" outlined @click.stop="openAttorneyFeeProcuratorDialog(fee)">
                                                    <v-icon left small>mdi-account-plus</v-icon>
                                                    Adicionar procurador
                                                </v-btn>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="Nome completo"
                                        v-model="fee.procurator_name"
                                        :disabled="!!fee.procurator_user_id && !fee.manual"
                                    />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="CPF/CNPJ"
                                        v-model="fee.procurator_registration"
                                        :disabled="!!fee.procurator_user_id && !fee.manual"
                                        @blur="formatAttorneyFeeRegistration(fee)"
                                    />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="OAB"
                                        v-model="fee.procurator_oab"
                                        :disabled="!!fee.procurator_user_id && !fee.manual"
                                    />
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-currency-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="Valor"
                                        :allowNegative="false"
                                        v-model="fee.amount"
                                    />
                                </v-col>
                                <v-col cols="12" md="1" class="d-flex align-center justify-end">
                                    <v-btn icon color="error" @click="removeAttorneyFee(index)">
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" md="4">
                                    <v-select
                                        dense
                                        outlined
                                        hide-details="auto"
                                        label="Classe"
                                        :items="dataset.creditorTypes"
                                        item-value="id"
                                        item-text="name"
                                        v-model="fee.type"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    <template #footer>
                        <v-btn v-if="$allowed('save')" color="primary" depressed :loading="dataset.attorneyFeesLoading" @click="saveAttorneyFees">
                            Salvar Honorários
                        </v-btn>
                    </template>
                </ui-section>

        <v-dialog v-model="attorneyFeeProcuratorDialog.show" max-width="700px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Adicionar procurador</h3>
                </div>
                <div class="ui-card__body">
                    <v-form :readonly="!$allowed('save')" ref="attorneyFeeProcuratorForm" v-model="attorneyFeeProcuratorDialog.valid">
                        <v-row>
                            <v-col cols="12">
                                <v-alert type="info" outlined dense>
                                    O novo procurador será vinculado apenas ao honorário deste pedido.
                                </v-alert>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    label="Nome completo"
                                    v-model="attorneyFeeProcuratorDialog.form.name"
                                    :rules="[$rules.required]"
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    label="CPF/CNPJ"
                                    v-model="attorneyFeeProcuratorDialog.form.registration"
                                    :rules="[$rules.required]"
                                    @input="formatAttorneyFeeDialogRegistration"
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    label="OAB (opcional)"
                                    v-model="attorneyFeeProcuratorDialog.form.oab"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="closeAttorneyFeeProcuratorDialog">Cancelar</v-btn>
                    <v-btn v-if="$allowed('create')" color="primary" depressed @click="confirmAttorneyFeeProcurator">Adicionar</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <!-- <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Negócios</span>
                            </div>
                            <v-col cols="3">
                                <v-progress-linear :value="dataset.loading ? undefined : progress" color="green"
                                    height="20" rounded :indeterminate="dataset.loading">
                                    <strong v-if="!dataset.loading" class="centered">{{ progress }}% analisados</strong>
                                    <span v-else class="centered">Carregando...</span>
                                </v-progress-linear>
                            </v-col>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Habilitação/Divergência</strong>
                                        <br />
                                        <strong>Devedora: </strong> <span>{{ getEventDebtorSummary() }}</span>
                                        <br />
                                        <strong>Solicitado em: </strong>
                                        <span>{{
                                            dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading">
                                    <v-col>
                                        <strong>Resultado: </strong>
                                        <v-chip small label class="mr-10" :color="getColorByStatus(getFinalStatus())">
                                            {{ getFinalStatus() | enum(dataset.eventStatus, 'id',
                                                'name') }}
                                        </v-chip>
                                    </v-col>
                                </v-row>

                                <v-row
                                    v-if="!dataset.loading && (!dataset.data.currentReview || dataset.data.currentReview.status !== 0)">
                                    <v-col>
                                        <v-btn type="button" elevation="0" color="#B39DDB" class="mr-5" small v-if="((dataset.data.status && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                            || !($check('Event', 'PATCH'))) && $allowed('event.archive')"
                                            @click="statusReset()">Restaurar</v-btn>

                                        <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="accent" class="mr-5" small
                                            :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6) || !getFinalStatus()"
                                            @click="updateStatus()">Confirmar</v-btn>

                                        <v-btn v-if="$allowed('event.review')" type="button" elevation="0" color="#FF8F00" small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                            || !($check('Event', 'PATCH'))"
                                            @click="createReview()" class="mr-5">Enviar
                                            para revisão</v-btn>

                                        <v-btn type="button" elevation="0" color="#7E55AB" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                                || !($check('Event', 'PATCH'))"
                                            @click.stop="openRequestDoc()">Solicitar
                                            Documento</v-btn>

                                        <v-btn v-if="$allowed('event.decide')" type="button" elevation="0" color="primary" class="mr-5 white--text"
                                            small :disabled="(dataset.data.status !== 0 && dataset.data.status !== 4 && dataset.data.status !== 5 && dataset.data.status !== 6)
                                                || !($check('Event', 'PATCH'))"
                                            @click.stop="openCreateBusinessModal()">Adicionar
                                            Negócio</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!dataset.loading && dataset.data.currentReview && dataset.data.currentReview.status == 0
                                    && $check('Event', 'PATCH')">
                                    <v-col>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-if="$allowed('edit')" v-on="on" type="button" elevation="0" color="accent" class="mr-5"
                                                    small @click="updateReview(1)">Aprovar</v-btn>
                                            </template>
                                            <span>Clique no botão para aprovar a revisão.</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-btn v-on="on" type="button" elevation="0" color="error" class="mr-5"
                                                    small @click="updateReview(2)">Rejeitar</v-btn>
                                            </template>
                                            <span>Clique no botão para rejeitar a revisão.</span>
                                        </v-tooltip>

                                    </v-col>
                                </v-row>



                                <v-row>
                                    <v-col>


                                        <v-expansion-panels>
                                            <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                :key="eventIndex">
                                                <v-expansion-panel-header>
                                                    <div class="d-flex align-center">
                                                        <strong>Origem: </strong>
                                                        <span>
                                                            {{
                                                                truncateText(
                                                                    eventItem.origin || 'N/A',
                                                                    30
                                                                )
                                                            }}
                                                        </span> &nbsp;
                                                        / &nbsp;
                                                        <strong>Valor: </strong>
                                                        <span v-if="eventItem.amount">
                                                            {{
                                                                eventItem.currency | enum(
                                                                    dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat'
                                                                )
                                                            }}
                                                            {{ eventItem.amount | currency }}
                                                        </span>
                                                        <span v-else>N/A</span>
                                                        <template v-if="getItemDebtorName(eventItem)">
                                                            &nbsp;
                                                            / &nbsp;
                                                            <strong>Devedora: </strong>
                                                            <span>{{ truncateText(getItemDebtorName(eventItem), 30) }}</span>
                                                        </template>

                                                        <v-btn v-if="(dataset.data.status === 0) && $allowed('edit')"
                                                            @click.stop="partialAcceptModal(eventItem)"
                                                            class="ml-auto mr-10" elevation="0" color="primary"
                                                            outlined>Editar valor
                                                        </v-btn>

                                                    </div>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col>
                                                            <p>
                                                                <span class="section-info-title">Devedora</span>
                                                                <br />
                                                                <span class="section-info-value">
                                                                    {{ getItemDebtorName(eventItem) }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Origem</span>
                                                                <br />
                                                                <span class="section-info-value">
                                                                    {{ eventItem.origin }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Moeda</span>
                                                                <br />
                                                                <span class="section-info-value">
                                                                    {{
                                                                        eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                    }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Valor</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                }}
                                                                    {{
                                                                        eventItem.amount | currency
                                                                    }}</span>
                                                            </p>

                                                            <p>
                                                                <span class="section-info-title">Valor parcial aceito</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                }}
                                                                    {{
                                                                        eventItem.partial_amount | currency
                                                                    }}</span>
                                                            </p>

                                                            <v-row>
                                                                <v-col cols="6">
                                                                    <span class="section-info-title">Classe</span>
                                                                    <v-autocomplete
                                                                        :disabled="dataset.data.status !== 0"
                                                                        dense
                                                                        :items="dataset.creditorTypes"
                                                                        v-model="eventItem.type"
                                                                        item-value="id"
                                                                        item-text="name"
                                                                        outlined
                                                                        hide-details="auto"
                                                                        required
                                                                        :rules="[$rules.required]"
                                                                        no-data-text="Nenhuma classe encontrada"
                                                                        @change="onAutocompleteChange(eventIndex)"
                                                                    >
                                                                    </v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="auto" v-if="eventItem.isChanged">
                                                                    <v-btn v-if="$allowed('save')" class="mt-6" @click="() => updateClassType(eventItem, eventIndex)" dense color="primary">
                                                                        Salvar
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                       
                                                            <br />
                                                            <p>
                                                                <span class="section-info-title">Observações</span>
                                                                <br />
                                                                <span class="section-info-value">
                                                                    {{ eventItem.observation }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Documentos</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.docs.length
                                                                }}
                                                                    arquivo(s)</span>
                                                                <br />
                                                                <v-btn v-if="$allowed('edit')" class="mt-3" small outlined color="primary"
                                                                    @click="openEditDocumentsDialog(eventItem)">
                                                                    <v-icon left small>mdi-file-document-edit-outline</v-icon>
                                                                    Editar documentos
                                                                </v-btn>
                                                            </p>
                                                             <v-row>
                                                                <v-col v-for="(docItem, docIndex ) in eventItem.docs" :key="docIndex">
                                                                    <v-img @click="openDoc(docItem.doc.file_url)"
                                                                        class="rounded-xl"
                                                                        lazy-src="https://picsum.photos/id/11/10/6"
                                                                        :height="100" :width="100"
                                                                        :src="docItem.doc.file_url"></v-img>
                                                                </v-col>
                                                            </v-row> 
                                                            <v-divider v-if="eventItem.docs.length > 0"></v-divider>
                                                            <br>
                                                            <v-row v-for="category in getEventItemsByCategory(eventItem)"
                                                                :key="category.id">
                                                                <v-col cols="12">
                                                                    <h3>{{ category.name }}</h3>
                                                                    <br>
                                                                    <v-row>
                                                                        <v-col v-for="doc in category.docs" :key="doc.id"
                                                                            cols="auto">
                                                                            <v-img @click="openDoc(doc.file_url)"
                                                                                class="rounded-xl"
                                                                                lazy-src="https://picsum.photos/id/11/10/6"
                                                                                :height="100" :width="100"
                                                                                :src="doc.file_url"></v-img>
                                                                            {{ doc.name }}
                                                                            <br>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

                        <ui-section v-if="dataset.data.requested_doc" title="Documentos solicitados" class="mt-4">
                            <div v-for="(item, index) in getRequestDoc()" :key="index">
                                <v-row v-for="(doc, indexDoc) in item.docs" :key="indexDoc">
                                    <v-col v-if="doc">
                                        <span v-if="item.user_event_item_id" class="primary--text" color="primary">
                                            - <strong>Negócio #{{ item.user_event_item_id }}: </strong>
                                            <template v-if="doc.id != 50">
                                                {{ doc.id | enum(businessDocTypes, 'id', 'name') }}
                                            </template>
                                            <template v-else>
                                                {{ doc.customName || doc.name }}
                                            </template>
                                        </span>
                                        <span v-else-if="doc.id != 3" class="primary--text" color="primary">
                                            - {{ doc.id | enum(creditorEmailDocTypes, 'id', 'name') }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </div>
                        </ui-section>

                        <ui-section title="Documento de apoio" description="Imagem ou PDF usado como base da análise." class="mt-4">
                            <ui-file-drop :file="dataset.data.helpDocument" :current-url="dataset.data.help_doc_url"
                                accept="image/*,application/pdf" hint="Imagem ou PDF de até 15 MB" :loading="dataset.loading"
                                @select="onFileSelected" @save="updateHelpDoc" @error="notifyEditorError" />
                        </ui-section>

        <!-- <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="ui-card" flat>
                            <div class="ui-card__header">
                                <h3 class="ui-section-title">Documento</h3>
                            </div>

                            <v-col cols="12">
                                <v-file-input dense :accept="acceptedDocumentTypes" prepend-icon="" outlined
                                    counter hint="PDF, imagem ou ZIP de até 1 GB" hide-details="auto"
                                    label="Documento" :clearable="true" @change="onFileSelected($event)" show-size
                                    truncate-length="50" ref="file">
                                </v-file-input>

                                <template v-if="dataset.data.reason_document_url">
                                    <v-row class="mt-n5">
                                        <v-col cols="12">
                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                :href="dataset.data.reason_document_url" target="_blank">Visualizar
                                                documento
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>

                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row> -->

                <ui-section title="Motivo" description="Motivo para aprovação ou rejeição">
                        <v-row>
                            <v-col cols="12">
                                <p class="font-weight-bold mb-2">Texto curto</p>
                                <ui-document-editor ref="smallReasonEditor" v-model="dataset.data.smallReason" orientation="landscape" :disabled="dataset.loading"
                                    :min-height="96" :max-height="240" no-fullscreen placeholder="Resumo do motivo">
                                    <template #toolbar>
                                        <button type="button" class="doc-toolbar__btn doc-toolbar__btn--text" title="Selecionar textos curtos predefinidos"
                                            @mousedown.prevent @click="openDialogDynamicText('smallReason')">
                                            <v-icon size="18">mdi-text-short</v-icon><span>Textos automáticos</span>
                                        </button>
                                    </template>
                                </ui-document-editor>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <p class="font-weight-bold mb-0">Texto longo</p>
                                    <v-btn
                                        color="primary"
                                        outlined
                                        small
                                        @click="openLongReasonDialog"
                                    >
                                        <v-icon left small>mdi-arrow-expand-all</v-icon>
                                        Expandir motivo
                                    </v-btn>
                                </div>
                                <ui-document-editor ref="reasonEditor" v-model="dataset.data.reason" orientation="landscape" :disabled="dataset.loading"
                                    :min-height="260" :max-height="560" no-fullscreen placeholder="Fundamentação da análise">
                                    <template #toolbar>
                                        <button type="button" class="doc-toolbar__btn doc-toolbar__btn--text" title="Selecionar textos longos predefinidos"
                                            @mousedown.prevent @click="openDialogDynamicText('reason')">
                                            <v-icon size="18">mdi-text-long</v-icon><span>Textos automáticos</span>
                                        </button>
                                    </template>
                                </ui-document-editor>
                            </v-col>
                        </v-row>

                    <template #footer>
                        <v-btn v-if="$allowed('event.decide')" 
                            color="primary" 
                            outlined 
                            :loading="dataset.loading" 
                            @click="saveReasons"
                        >
                            Salvar Motivo
                        </v-btn>

                        <v-btn 
                            v-if="(dataset.data.status === 0) && $allowed('event.decide')"
                            color="primary" 
                            depressed
                            :loading="dataset.loading" 
                            @click="updateStatus"
                        >
                            Confirmar
                        </v-btn>
                    </template>
                </ui-section>

                <ui-section title="Comentários" description="Anotações internas sobre esta habilitação/divergência">
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="dataset.comment"
                                    :disabled="dataset.commentLoading"
                                    label="Novo comentário"
                                    outlined
                                    rows="3"
                                    counter="1000"
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn v-if="$allowed('create')"
                                    color="primary"
                                    depressed
                                    :loading="dataset.commentLoading"
                                    @click="saveComment"
                                >
                                    Adicionar comentário
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <v-alert v-if="!eventComments.length" type="info" outlined dense>
                            Nenhum comentário cadastrado.
                        </v-alert>

                        <div v-else class="event-comments-list">
                            <div
                                v-for="comment in eventComments"
                                :key="comment.id"
                                class="event-comment-item"
                            >
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <strong>{{ commentAuthor(comment) }}</strong>
                                    <span class="text-caption ui-muted">
                                        {{ formatDateTime(comment.created_at) }}
                                    </span>
                                </div>
                                <div class="event-comment-text">
                                    {{ comment.comments || comment.comment }}
                                </div>
                            </div>
                        </div>
                </ui-section>

        <!--Modal adicionar um novo negocio-->
        <v-dialog v-model="dialogCreateBusiness" class="elevation-0" max-width="800px">

            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Adicionar negócio</h3>
                </div>
                <v-card-text>
                    <v-form :readonly="!$allowed('save')" ref="newBusinessForm" v-model="dataForm.validForm">
                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Informe a origem do negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Digite o motivo que gerou os valores do negócio</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n4">
                            <v-col>

                                <v-text-field :disabled="dataset.loading" dense label="Origem do negócio"
                                    v-model="dataset.newBusiness.origin" required :rules="[$rules.required]" outlined
                                    hide-details="auto">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <span class="mr-3"><strong>Informe a moeda e o valor referente ao
                                        negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o tipo de moeda e o valor devido</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="6">
                                <v-select :disabled="dataset.loading" dense id="type" :items="dataset.currencyTypes"
                                    label="Selecione uma moeda" v-model="dataset.newBusiness.currency" item-value="id"
                                    item-text="name" :rules="[$rules.required]" outlined hide-details="auto"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-currency-field :disabled="dataset.loading" label="Valor" dense
                                    aria-label="Digite o valor do negócio" v-model="dataset.newBusiness.amount"
                                    :allowNegative="false" hide-details="auto" outlined required
                                    :rules="[$rules.required]"></v-currency-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Selecione a empresa devedora</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a empresa devedora do crédito</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-autocomplete :disabled="dataset.loading" dense required
                                    :items="getDebtorCompanyOptions(dataset.newBusiness.company_name)"
                                    label="Selecione a devedora" v-model="dataset.newBusiness.company_name"
                                    item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                    hide-details="auto"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                            <v-col cols="12">
                                <span class="mr-3"> <strong>Informe o número de identificação do
                                        pedido/cotação/contrato/outro</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informe o número de identificação do pedido</span>
                                </v-tooltip>

                            </v-col>

                        </v-row>
                        <v-row class="mt-n4">
                            <v-col cols="12">
                                <v-text-field :disabled="dataset.loading" dense label="Identificação do pedido"
                                    v-model="dataset.newBusiness.request_number"
                                    aria-label="Digite o numero de identificação do pedido" outlined hide-details="auto"
                                    :rules="[$rules.required]">
                                </v-text-field>
                            </v-col>
                        </v-row> -->

                        <v-row>
                            <v-col cols="12" sm="12">
                                <span class="mr-3"> <strong>Informe a classe no
                                        processo</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Selecione a classe no processo</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n4">
                            <v-col cols="12" sm="12">
                                <v-select dense :items="dataset.creditorTypes" label="Classe"
                                    v-model="dataset.newBusiness.type" item-value="id" item-text="name" outlined
                                    hide-details="auto" :rules="[$rules.required]">
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3">
                                    <strong>Adicione documento(s) comprobatório(s) do negócio</strong>
                                </span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Documentos que comprovem a origem do negócio</span>
                                </v-tooltip>
                            </v-col>

                            <v-col cols="12" lg="12" class="mt-n4">
                                <v-text-field outlined dense readonly hide-details :rules="[filesRequired]"
                                    prepend-icon="mdi-paperclip" :disabled="dataset.loading" @click="triggerFileInput">
                                    <template v-slot:prepend-inner>
                                        <div class="d-flex flex-wrap align-left v-chips-container">
                                            <v-chip v-for="(file, index) in dataset.newBusiness.docs" :key="index"
                                                class="ma-1" outlined small close @click:close="removeFile(index)">
                                                {{ file.name }}
                                            </v-chip>
                                        </div>
                                    </template>
                                </v-text-field>

                                <v-file-input ref="fileInput" dense multiple hide-input @change="addFiles"
                                    style="display: none"></v-file-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <span class="mr-3"><strong>Informe uma observação referente ao negócio</strong></span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon small :color="'primary'" v-bind="attrs"
                                            v-on="on">mdi-help-circle</v-icon>
                                    </template>
                                    <span>Informações adicionais referente ao negócio</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" class="mt-n4">
                                <v-textarea :disabled="dataset.loading" dense id="description"
                                    label="Informações Adicionais" :rules="[
                                        $rules.maxlength(
                                            dataset.newBusiness.observation,
                                            500
                                        )
                                    ]" counter="500" v-model="dataset.newBusiness.observation" outlined
                                    hide-details="auto" rows="2" auto-grow></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-row class="mt-n5 mr-1 justify-end">
                        <v-col cols="auto">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn v-if="$allowed('event.launch')" v-on="on" color="primary" :loading="dataset.loadingSave"
                                        @click.native="saveNewBusiness">
                                        Salvar
                                    </v-btn>
                                </template>
                                <span>Salvar alterações</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                        @click="closeDialogCreateBusiness()">
                                        Cancelar
                                    </v-btn>
                                </template>
                                <span>Retornar sem salvar alterações</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Modal solicitar novos documentos-->
        <v-dialog v-model="dialogRequestDoc" max-width="700px">
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Seleção de Documentos</h3>
                </div>

                <div class="ui-card__body">
                    <v-container class="pa-0">
                        <p>
                            Selecione o(s) documento(s) que deseja solicitar ao credor <strong>{{ dataset.data.user &&
                                dataset.data.user.name
                                }}</strong>.
                        </p>
                        <v-alert dense text type="info" v-if="dataset.data">
                            A solicitação utilizará o e-mail
                            <strong>{{ dataset.data.contact_email || (dataset.data.user && dataset.data.user.email) || 'não informado' }}</strong>
                            <template v-if="dataset.data.contact_name">
                                do contato <strong>{{ dataset.data.contact_name }}</strong>
                            </template>.
                        </v-alert>
                        <v-checkbox v-for="doc in creditorBusinessDocType" :key="doc.id" :label="doc.name" :value="doc.id"
                            v-model="selectedRequestDocs" class="mt-0 mb-0"
                            @change="handleDocumentSelection(doc.id)"></v-checkbox>
                        <div v-if="selectedRequestDocs.includes(3)">
                            <v-divider class="my-4"></v-divider>
                            <span class="font-weight-bold">
                                Selecione o(s) Documento(s) do(s) negócio(s):
                            </span>
                            <v-expansion-panels>
                                <v-expansion-panel v-for="item in dataset.data.items" :key="item.id">
                                    <v-expansion-panel-header>
                                        <div class="d-flex align-center">
                                            <strong>Origem: </strong>
                                            <span class="ml-2 mr-2">
                                                {{
                                                    truncateText(
                                                        item.origin || 'N/A',
                                                        30
                                                    )
                                                }}
                                            </span>
                                            /
                                            <strong class="ml-2">Valor: </strong>
                                            <span class="ml-2" v-if="item.amount">
                                                {{
                                                    item.currency | enum(
                                                        dataset.currencyTypes,
                                                        'id',
                                                        'currencyFormat'
                                                    )
                                                }}
                                                {{ item.amount | currency }}
                                            </span>
                                            <span v-else>N/A</span>
                                            <template v-if="getItemDebtorName(item)">
                                                /
                                                <strong class="ml-2">Devedora: </strong>
                                                <span class="ml-2">
                                                    {{ truncateText(getItemDebtorName(item), 30) }}
                                                </span>
                                            </template>

                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-checkbox v-for="doc in businessDocTypes" :key="doc.id" :label="doc.name"
                                            :value="doc.id" v-model="selectedBusinessDocs[item.id].docs"
                                            class="mt-0 mb-0" :disabled="!selectedBusinessDocs[item.id]"
                                            :input-value="selectedBusinessDocs[item.id] && selectedBusinessDocs[item.id].docs.includes(doc.id)"
                                            @change="handleDocumentSelection(doc.id, item)"></v-checkbox>

                                        <v-text-field
                                            v-if="selectedBusinessDocs[item.id] && selectedBusinessDocs[item.id].docs.includes(50)"
                                            v-model="selectedBusinessDocs[item.id].customName"
                                            label="Especifique o documento" outlined dense></v-text-field>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                        <br>
                        <!-- <v-row>
                            <v-col>
                                <v-card outlined>
                                    <v-card-text>
                                        <v-row class="align-center">
                                            <v-col cols="12" sm="12" class="d-flex align-center">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on">
                                                            <v-switch v-model="dataset.analysis_return"
                                                                label="Retornar para análise mesmo sem documentos"
                                                                hide-details class="mt-n2"
                                                                @change="switchChange"></v-switch>
                                                        </div>
                                                    </template>
                                                    <span>Se ativado, este pedido retornará para análise mesmo que o
                                                        credor não
                                                        tenha enviado os documentos solicitados.</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row> -->
                    </v-container>
                </div>
                <div class="ui-card__footer">
                    <v-btn :loading="dataset.loading" type="button" depressed color="primary"
                        @click="sendSelectedList">
                        Solicitar
                    </v-btn>
                    <v-btn text @click="closeDialogRequestDoc">Cancelar</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPortability" max-width="640px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Portabilizar pedido</h3>
                    <v-btn icon small @click="closePortabilityDialog" :disabled="portability.loading">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="ui-card__body">
                    <v-alert type="info" text dense>
                        Informe o credor de destino. Se já existir uma conta com este CPF/CNPJ, ela será reutilizada;
                        caso contrário, será criada uma conta temporária.
                    </v-alert>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field dense outlined label="Nome completo"
                                v-model="portability.form.user_name" :rules="[$rules.required]"
                                hide-details="auto">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field dense outlined label="CPF/CNPJ"
                                v-model="portability.form.user_registration" :rules="[$rules.required]"
                                hide-details="auto" @input="formatPortabilityRegistration">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field dense outlined label="E-mail"
                                v-model="portability.form.user_email" hide-details="auto">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>

                <div class="ui-card__footer">
                    <v-btn text @click="closePortabilityDialog" :disabled="portability.loading">Cancelar</v-btn>
                    <v-btn color="primary" depressed :loading="portability.loading" @click="savePortability">
                        Portabilizar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEditDocuments" max-width="900px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Editar documentos do negócio</h3>
                    <v-btn icon small @click="closeEditDocumentsDialog" :disabled="editDocuments.loading">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="ui-card__body">
                    <v-alert type="info" text dense>
                        Remova documentos vinculados ao negócio ou adicione novos arquivos. O arquivo original não será
                        apagado do storage.
                    </v-alert>

                    <template v-if="editDocuments.item">
                        <p class="mb-1">
                            <strong>Origem:</strong>
                            {{ editDocuments.item.origin || 'N/A' }}
                        </p>
                        <p>
                            <strong>Valor:</strong>
                            {{ editDocuments.item.currency | enum(dataset.currencyTypes, 'id', 'currencyFormat') }}
                            {{ editDocuments.item.amount | currency }}
                        </p>
                        <p v-if="getItemDebtorName(editDocuments.item)">
                            <strong>Devedora:</strong>
                            {{ getItemDebtorName(editDocuments.item) }}
                        </p>
                    </template>

                    <v-divider class="my-4"></v-divider>

                    <h3 class="mb-3">Documentos atuais</h3>
                    <v-row v-if="editDocuments.item && editDocuments.item.docs && editDocuments.item.docs.length">
                        <v-col v-for="category in getEventItemsByCategory(editDocuments.item)" :key="category.id"
                            cols="12">
                            <h4 class="mb-2">{{ category.name }}</h4>
                            <v-row>
                                <v-col v-for="doc in category.docs" :key="doc.id" cols="12" sm="6" md="4">
                                    <v-card outlined
                                        :class="['edit-doc-card', isDocumentMarkedForRemoval(doc.id) ? 'edit-doc-card--remove' : '']">
                                        <v-card-text class="d-flex align-center">
                                            <v-icon class="mr-3" color="primary">mdi-file-document-outline</v-icon>
                                            <div class="flex-grow-1 text-truncate">
                                                <strong>{{ doc.name }}</strong>
                                                <br />
                                                <a @click.prevent="openDoc(doc.file_url)">Visualizar documento</a>
                                            </div>
                                            <v-btn icon color="error" @click="toggleRemoveDocument(doc.id)">
                                                <v-icon>
                                                    {{ isDocumentMarkedForRemoval(doc.id) ? 'mdi-undo' : 'mdi-delete-outline' }}
                                                </v-icon>
                                            </v-btn>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-alert v-else text dense type="warning">
                        Nenhum documento vinculado ao negócio.
                    </v-alert>

                    <v-divider class="my-4"></v-divider>

                    <h3 class="mb-3">Adicionar novos documentos</h3>
                    <v-row>
                        <v-col cols="12" sm="5">
                            <v-select :items="documentTypes" v-model="editDocuments.docType" item-value="id"
                                item-text="name" label="Categoria dos novos documentos" outlined dense
                                hide-details="auto">
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="7">
                            <v-text-field outlined dense readonly hide-details prepend-icon="mdi-paperclip"
                                label="Selecionar documentos" :disabled="editDocuments.loading"
                                @click="triggerEditDocumentFileInput">
                                <template v-slot:append>
                                    <v-icon>mdi-upload</v-icon>
                                </template>
                            </v-text-field>

                            <v-alert v-if="editDocuments.uploadProgress" type="info" text dense class="mb-3">
                                Enviando <strong>{{ editDocuments.uploadProgress.name }}</strong>... {{ editDocuments.uploadProgress.percent }}%
                                <v-progress-linear :value="editDocuments.uploadProgress.percent" height="6" rounded class="mt-2"></v-progress-linear>
                            </v-alert>
                            <v-file-input ref="editDocumentFileInput" dense multiple hide-input :accept="acceptedDocumentTypes"
                                @change="addEditDocumentFiles" style="display: none"></v-file-input>
                        </v-col>
                    </v-row>

                    <div class="d-flex flex-wrap mt-2">
                        <v-chip v-for="(file, index) in editDocuments.files" :key="`${file.name}-${index}`"
                            class="ma-1" small outlined close @click:close="removeEditDocumentFile(index)">
                            {{ file.name }}
                        </v-chip>
                    </div>
                </div>

                <div class="ui-card__footer">
                    <v-btn text @click="closeEditDocumentsDialog" :disabled="editDocuments.loading">
                        Cancelar
                    </v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed :loading="editDocuments.loading" @click="saveEventItemDocuments">
                        Salvar documentos
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDynamicText" :width="900">
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div class="font-weight-bold mt-6 title-page">Textos Automáticos</div>
                            <p class="mt-2">
                                Selecione um texto abaixo para adicionar no motivo
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>
                                <v-list-item two-line
                                    v-for="(item, index) in dataset.dynamicTexts.filter((x) => (targetField == 'smallReason' && x.small_description) || (targetField != 'smallReason' && x.description))"
                                    :key="index" style="cursor: pointer" @click="selectDynamicText(item)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div
                                                v-html="targetField == 'smallReason' ? item.small_description : truncateText(item.description, 150)">
                                            </div>
                                            <v-divider></v-divider>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <!-- <v-card class="rounded-lg mb-10" v-for="(item, index) in dataset.dynamicTexts" :key="index"
                                elevation="2">
                                <v-card-title>
                                    {{ item.name }}
                                </v-card-title>
                                <v-card-text>
                                    <div v-html="dynamicTextSmallType ? item.small_description : item.description"></div>
                                </v-card-text>
                            </v-card> -->
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn type="button" elevation="0" color="error"
                                @click="dialogDynamicText = false;">Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLongReason" fullscreen hide-overlay transition="dialog-bottom-transition">
            <div class="reason-workspace">
                <header class="reason-workspace__bar">
                    <div class="reason-workspace__heading">
                        <h2 class="reason-workspace__title">Motivo</h2>
                        <span class="reason-workspace__subtitle">Fundamentação da análise do pedido</span>
                    </div>
                    <span class="reason-workspace__spacer"></span>
                    <v-btn outlined :class="{ 'reason-workspace__toggle--on': supportPanelOpen }" @click="supportPanelOpen = !supportPanelOpen">
                        <v-icon left small>mdi-paperclip</v-icon>
                        Documento de apoio
                        <span v-if="dataset.data.help_doc_url || dataset.data.helpDocument" class="ui-tab-count">1</span>
                    </v-btn>
                    <v-btn v-if="$allowed('event.decide')" color="primary" depressed :loading="dataset.loading" @click="saveReasons">Salvar motivo</v-btn>
                    <v-btn icon aria-label="Fechar" @click="dialogLongReason = false"><v-icon>mdi-close</v-icon></v-btn>
                </header>

                <div class="reason-workspace__body">
                    <ui-document-editor ref="reasonEditorDialog" v-model="dataset.data.reason" orientation="landscape" :disabled="dataset.loading"
                        class="reason-workspace__editor" page no-fullscreen placeholder="Fundamentação da análise">
                        <template #toolbar>
                            <button type="button" class="doc-toolbar__btn doc-toolbar__btn--text" title="Selecionar textos longos predefinidos"
                                @mousedown.prevent @click="openDialogDynamicText('reason')">
                                <v-icon size="18">mdi-text-long</v-icon><span>Textos automáticos</span>
                            </button>
                        </template>
                    </ui-document-editor>

                    <aside v-if="supportPanelOpen" class="reason-workspace__panel" aria-label="Documento de apoio">
                        <div class="reason-workspace__panel-head">
                            <div>
                                <h3 class="ui-section-title">Documento de apoio</h3>
                                <p class="ui-section-description">Imagem ou PDF usado como base da análise.</p>
                            </div>
                            <v-btn icon small aria-label="Ocultar painel" @click="supportPanelOpen = false"><v-icon small>mdi-chevron-right</v-icon></v-btn>
                        </div>
                        <ui-file-drop :file="dataset.data.helpDocument" :current-url="dataset.data.help_doc_url"
                            accept="image/*,application/pdf" hint="Imagem ou PDF de até 15 MB" :loading="dataset.loading"
                            @select="onFileSelected" @save="updateHelpDoc" @error="notifyEditorError" />
                    </aside>
                </div>
            </div>
        </v-dialog>


        <!-- Crédito adicional do negócio: outra classe/valor/moeda -->
        <v-dialog v-model="itemCredit.dialog" max-width="560" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">{{ itemCredit.id ? 'Editar crédito adicional' : 'Adicionar classe/valor' }}</h3>
                </div>
                <div class="ui-card__body">
                    <v-select v-model="itemCredit.type" :items="dataset.creditorTypes"
                        item-value="id" item-text="name" label="Classe *" outlined dense
                        :disabled="itemCredit.saving"></v-select>

                    <v-currency-field v-model="itemCredit.amount" label="Valor *"
                        :allow-negative="false" outlined dense
                        :disabled="itemCredit.saving"></v-currency-field>

                    <v-select v-model="itemCredit.currency" :items="dataset.currencyTypes"
                        item-value="id" item-text="name" label="Moeda *" outlined dense
                        :disabled="itemCredit.saving"></v-select>

                    <v-text-field v-model="itemCredit.description" label="Descrição (opcional)"
                        outlined dense :disabled="itemCredit.saving"
                        hide-details="auto"></v-text-field>
                </div>
                <div class="ui-card__footer">
                    <v-btn text :disabled="itemCredit.saving" @click="itemCredit.dialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed :loading="itemCredit.saving"
                        @click="saveItemCredit">Salvar</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPartialAccept" :width="700">
            <v-card :max-height="500" v-if="dataset.selectedItem">
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div class="font-weight-bold mt-6 title-page">Aceitar parcialmente</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <p>
                                <span class="section-info-title ">Valor solicitado credor</span>
                                <br />
                                <span class="text-h6">{{
                                    dataset.selectedItem.currency
                                    | enum(
                                        dataset.currencyTypes,
                                        'id',
                                        'currencyFormat'
                                    )
                                }}
                                    {{ dataset.selectedItem.amount | currency }}
                                </span>
                            </p>

                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <span class="section-info-title">Digite valor aceito</span>
                            <br />
                            <br />
                            <v-currency-field label="Valor" dense v-model="dataset.selectedItem.partialAmount"
                                :allowNegative=false hide-details="auto" outlined class="mt-n3">
                            </v-currency-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <div class="mr-10 ml-2">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" @click="savePartialValue()" color="primary" dark elevation="2"
                                    :loading="dataset.loading">
                                    OK
                                </v-btn>
                            </template>
                            <span>Salvar valor parcial</span>
                        </v-tooltip>
                    </div>
                    <div>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" color="grey" text
                                    @click.native="dialogPartialAccept = false">Cancelar</v-btn>
                            </template>
                            <span>Fechar</span>
                        </v-tooltip>
                    </div>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>





    </div>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import userEventUtil from "@/common/util/user-event.util"

import userTypes from "@/common/data/user-types.data"
import currencyTypes from "@/common/data/currency-types.data"

import documentTypes from "@/common/data/document-types.data"
import axios from "axios"
import { needsChunkedUpload, chunkedUpload, validateDocumentFile, ACCEPTED_DOCUMENT_TYPES } from "@/common/util/chunked-upload"
import creditorTypes from "@/common/data/creditor-types.data"
import creditorClassUtil from "@/common/util/creditor-class.util"
import { cpf, cnpj } from 'cpf-cnpj-validator'
import creditorEmailDocTypes from "@/common/data/creditor-email-doc-types.data"
//import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import eventStatus from "@/common/data/event-status.data"
import businessDocTypes from "@/common/data/business-doc-types.data"
import AIAnalysisButton from "@/components/AIAnalysisButton.vue"







export default {
    name: "UserDetails",

    components: {
        'ai-analysis-button': AIAnalysisButton,
    },

    data: () => ({
        lateFilingSaving: false,
        page: {
            isNew: false,
            title: "",
        },
        itemCredit: {
            dialog: false,
            saving: false,
            id: null,
            itemId: null,
            type: null,
            amount: null,
            currency: 1,
            description: "",
        },
        targetField: '',
        selectedRequestDocs: [],
        selectedBusinesses: [],
        selectedBusinessDocs: {},
        customDocumentName: "",
        expandedPanels: [],
        creditorBusinessDocType: [{ id: 3, name: 'Documentos comprobatórios' }],
        businessDocTypes: businessDocTypes,
        creditorEmailDocTypes: creditorEmailDocTypes,
        documentTypes: documentTypes,
        attorneyFeeScopes: [
            { id: "request", name: "Pedido inteiro" },
            { id: "item", name: "Por negócio" },
        ],
        dataset: {
            userTypes: userTypes,
            currencyTypes: currencyTypes,
           // creditorOriginTypes: creditorOriginTypes,
            eventStatus: eventStatus,
            breadcrumbItems: [],
            states: states,
            selectedItem: null,
            loading: false,
            loadingSave: false,
            clients: [],
            procurators: [],
            procuratorsLoading: false,
            attorneyFees: [],
            attorneyFeesLoading: false,
            analysis_return: false,
            creditorTypes: creditorTypes,
            newBusiness: {
                origin: null,
                amount: null,
                currency: null,
                company_name: null,
                type: null,
                docs: [],
                observation: null,

            },
            data: {
                smallReason: "",
                reason: "",
                partialAmount: null,
                reasonDocument: null,
                helpDocument: null,
                processes: [],
                review_later: false,
            },
            partialItems: [],
            dynamicTexts: [],
            events: [],
            comment: "",
            commentLoading: false,
            reasonIsDeleting: false,
        },
        isEditing: false,
        documentsDownloadLoading: false,
        editedAmount: null,
        editedPartialAmount: null,
        editedCurrency: null,
        editedOrigin:null,
        editedReason: null,
        partialAmountError: '',
        editedRequestNumber: null,
        expandedPanel: null,
        progress: 0,
        dialogDynamicText: false,
        dialogPartialAccept: false,
        dynamicTextSmallType: false,
        dialogLongReason: false,
        selectedDoc: null,
        helpDocumentPreviewUrl: null,
        supportPanelOpen: true,
        dialogViewDoc: false,
        dialogRequestDoc: false,
        dialogPortability: false,
        attorneyFeeProcuratorDialog: {
            show: false,
            valid: true,
            fee: null,
            form: {
                name: "",
                registration: "",
                oab: "",
            },
        },
        portability: {
            loading: false,
            form: {
                user_name: "",
                user_registration: "",
                user_email: "",
            },
        },
        dialogEditDocuments: false,
        editDocuments: {
            item: null,
            files: [],
            removeDocIds: [],
            docType: 3,
            loading: false,
            // Progresso do envio em partes pela API (arquivos grandes / ZIP): { name, percent }
            uploadProgress: null,
        },
        acceptedDocumentTypes: ACCEPTED_DOCUMENT_TYPES,
        dialogCreateBusiness: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Exemplo de texto com uma imagem:'
                    },
                    {
                        type: 'image',
                        attrs: {
                            src: 'https://via.placeholder.com/150',
                            alt: 'Imagem de exemplo',
                            style: 'width: 150px; height: 150px;' // Estilo para definir largura e altura da imagem
                        }
                    }
                ]
            }
        ],
    }),

    created() {
        this.setPage();
    },

    computed: {
        // Documentos do contraditorio; pedidos antigos sem a lista usam o arquivo unico.
        contradictoryFiles() {
            const data = this.dataset.data || {};
            if (Array.isArray(data.contradictory_files) && data.contradictory_files.length) return data.contradictory_files;
            return data.contradictory_reason_file_url ? [{ id: 'legacy', name: 'Documento do contraditório', url: data.contradictory_reason_file_url }] : [];
        },
        // Tipo do documento do credor, pelo Content-Type do storage: pdf | image | other.
        creditorDocumentKind() {
            const user = this.dataset.data && this.dataset.data.user;
            const type = String((user && user.url_document_type) || '').toLowerCase();
            if (type === 'application/pdf') return 'pdf';
            if (type.startsWith('image/')) return 'image';
            return 'other';
        },
        creditorDocumentTypeLabel() {
            const user = this.dataset.data && this.dataset.data.user;
            const type = String((user && user.url_document_type) || '').toLowerCase();
            if (type.includes('zip')) return 'arquivo compactado .zip';
            return type || 'formato desconhecido';
        },
        editalCredits() {
            return Array.isArray(this.dataset.data.edital_credits) ? this.dataset.data.edital_credits : [];
        },
        editalTotal() {
            return this.editalCredits.reduce((sum, credit) => sum + Number(credit.amount || 0), 0);
        },
        documentsCount() {
            const items = this.dataset.data && Array.isArray(this.dataset.data.items)
                ? this.dataset.data.items
                : [];

            return items.reduce((total, item) => total + (Array.isArray(item.docs) ? item.docs.length : 0), 0);
        },

        attorneyFeeItemOptions() {
            const items = this.dataset.data && Array.isArray(this.dataset.data.items)
                ? this.dataset.data.items
                : [];

            return items.map((item) => ({
                id: item.id,
                name: `#${item.id} - ${item.origin || "Negócio"} - ${this.getCreditorTypeName(item.type)}`,
            }));
        },

        eventComments() {
            if (!this.dataset.data || !Array.isArray(this.dataset.data.comments)) return [];

            return [...this.dataset.data.comments].sort((a, b) => {
                return new Date(b.created_at || 0) - new Date(a.created_at || 0);
            });
        },
    },

    watch: {
        'dataset.data.reason': function () {
            this.reasonUpdateRemainingChars();
        },

        'dataset.data.items': {
            immediate: true,
            handler(newItems) {
                if (newItems) {
                    newItems.forEach(item => {
                        if (!this.selectedBusinessDocs[item.id]) {
                            this.$set(this.selectedBusinessDocs, item.id, {
                                docs: [],
                                origin: item.origin,
                                amount: item.amount,
                            });
                        } else {
                            this.selectedBusinessDocs[item.id].docs = this.selectedBusinessDocs[item.id].docs.map(doc => {
                                return typeof doc === 'object' ? doc : { id: doc, uploaded: false };
                            });
                        }
                    });
                }
            }
        }
    },

    mounted() {
        this.user = this.$root.user.data || this.$root.user;
        console.log(this.user)
        this.loadData();

        // this.initializeAnalysisStatus();
    },

    beforeDestroy() {
        if (this.helpDocumentPreviewUrl && this.helpDocumentPreviewUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.helpDocumentPreviewUrl);
        }
    },

    methods: {
        async updateLateFiling(value) {
            const previous = this.dataset.data.late_filing;
            this.$set(this.dataset.data, 'late_filing', value ? 1 : 0);
            this.lateFilingSaving = true;
            try {
                await axios.patch(`/api/admin/user-events/late-filing/${this.dataset.data.id}`, { late_filing: value ? 1 : 0 });
                this.$dialog.notify.success(value ? 'Pedido marcado como retardatário.' : 'Marca de retardatário removida.', { position: 'top-right', timeout: 3000 });
            } catch (error) {
                this.$set(this.dataset.data, 'late_filing', previous);
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao atualizar o pedido', { position: 'top-right', timeout: 5000 });
            } finally {
                this.lateFilingSaving = false;
            }
        },

        async downloadDocuments() {
            this.documentsDownloadLoading = true;

            try {
                const response = await axios.get(
                    `/api/admin/user-events/${this.dataset.data.id}/documents/download`,
                    { responseType: 'blob' }
                );
                const disposition = response.headers['content-disposition'] || '';
                const match = disposition.match(/filename="?([^";]+)"?/i);
                const fileName = match ? match[1] : `documentos-pedido-${this.dataset.data.id}.zip`;
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
                const link = document.createElement('a');

                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                let message = this.$codes(error);

                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const payload = JSON.parse(await error.response.data.text());
                        message = payload.message || message;
                    } catch (parseError) {
                        // Mantém a mensagem normalizada da aplicação.
                    }
                }

                this.$dialog.notify.error(message || 'Não foi possível baixar os documentos.', {
                    position: 'top-right',
                    timeout: 3000,
                });
            } finally {
                this.documentsDownloadLoading = false;
            }
        },

        stripHtml(html) {
            if (!html) return "";
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            let text = tmp.textContent || tmp.innerText || "";
            return text.trim();
        },

        getMainDebtorName() {
            return this.dataset.data && this.dataset.data.client ? this.dataset.data.client.name : "";
        },

        getDebtorCompanyOptions(selectedName = "") {
            const client = this.dataset.data && this.dataset.data.client ? this.dataset.data.client : null;
            const names = [];

            if (client && client.name) names.push(client.name);

            if (client && Array.isArray(client.companies)) {
                client.companies.forEach(company => {
                    if (company && company.name) names.push(company.name);
                });
            }

            if (selectedName) names.push(selectedName);

            return [...new Set(names.filter(Boolean))].map(name => ({ name }));
        },

        getItemDebtorName(item) {
            return item && item.company_name ? item.company_name : this.getMainDebtorName();
        },

        getEventDebtorSummary() {
            const names = this.getDebtorCompanyOptions().map(company => company.name);

            if (!names.length) return "N/A";

            return names.join(" / ");
        },

        goBack() {
            this.$router.replace("/divergencias");
        },

        onlyDigits(value) {
            return String(value || "").replace(/\D/g, "");
        },

        formatRegistrationValue(value) {
            const digits = this.onlyDigits(value);
            if (!digits) return "";

            return digits.length <= 11 ? cpf.format(digits) : cnpj.format(digits.slice(0, 14));
        },

        defaultAttorneyFee() {
            return {
                localId: `fee-${Date.now()}-${Math.random()}`,
                scope: "request",
                user_event_item_id: null,
                procurator_user_id: null,
                procurator_name: "",
                procurator_registration: "",
                procurator_oab: "",
                amount: null,
                type: null,
                manual: true,
            };
        },

        normalizeAttorneyFees(fees = []) {
            return fees.map((fee) => ({
                ...this.defaultAttorneyFee(),
                ...fee,
                localId: `fee-${fee.id || Date.now()}-${Math.random()}`,
                scope: fee.user_event_item_id ? "item" : "request",
                procurator_user_id: fee.procurator_user_id || null,
                procurator_name: fee.procurator_name || (fee.procurator ? fee.procurator.name : ""),
                procurator_registration: this.formatRegistrationValue(
                    fee.procurator_registration || (fee.procurator ? fee.procurator.registration : "")
                ),
                procurator_oab: fee.procurator_oab || (fee.procurator ? fee.procurator.oab : ""),
                manual: !fee.procurator_user_id,
            }));
        },

        addAttorneyFee() {
            this.dataset.attorneyFees.push(this.defaultAttorneyFee());
        },

        removeAttorneyFee(index) {
            this.dataset.attorneyFees.splice(index, 1);
        },

        onAttorneyFeeScopeChange(fee) {
            if (fee.scope !== "item") fee.user_event_item_id = null;
        },

        formatAttorneyFeeRegistration(fee) {
            fee.procurator_registration = this.formatRegistrationValue(fee.procurator_registration);
        },

        formatAttorneyFeeProcurator(item) {
            if (!item) return "";

            const registration = item.registration ? this.formatRegistrationValue(item.registration) : "CPF/CNPJ não informado";
            const oab = item.oab ? ` - OAB ${item.oab}${item.oab_state ? `/${item.oab_state}` : ""}` : "";

            return `${item.name} - ${registration}${oab}`;
        },

        onAttorneyFeeProcuratorChange(fee) {
            const procurator = this.dataset.procurators.find((item) => Number(item.id) === Number(fee.procurator_user_id));

            if (!procurator) {
                fee.manual = true;
                return;
            }

            fee.manual = false;
            fee.procurator_name = procurator.name || "";
            fee.procurator_registration = this.formatRegistrationValue(procurator.registration);
            fee.procurator_oab = procurator.oab ? `${procurator.oab}${procurator.oab_state ? `/${procurator.oab_state}` : ""}` : "";
        },

        enableManualAttorneyFee(fee) {
            fee.manual = true;
            fee.procurator_user_id = null;
            fee.procurator_name = "";
            fee.procurator_registration = "";
            fee.procurator_oab = "";
        },

        openAttorneyFeeProcuratorDialog(fee) {
            this.attorneyFeeProcuratorDialog = {
                show: true,
                valid: true,
                fee,
                form: {
                    name: "",
                    registration: "",
                    oab: "",
                },
            };
        },

        closeAttorneyFeeProcuratorDialog() {
            this.attorneyFeeProcuratorDialog.show = false;
            this.attorneyFeeProcuratorDialog.fee = null;
        },

        formatAttorneyFeeDialogRegistration() {
            this.attorneyFeeProcuratorDialog.form.registration = this.formatRegistrationValue(
                this.attorneyFeeProcuratorDialog.form.registration
            );
        },

        confirmAttorneyFeeProcurator() {
            if (!this.$refs.attorneyFeeProcuratorForm.validate()) return;

            const fee = this.attorneyFeeProcuratorDialog.fee;
            const form = this.attorneyFeeProcuratorDialog.form;

            if (!fee) return;

            fee.manual = true;
            fee.procurator_user_id = null;
            fee.procurator_name = form.name;
            fee.procurator_registration = this.formatRegistrationValue(form.registration);
            fee.procurator_oab = form.oab;

            this.closeAttorneyFeeProcuratorDialog();
        },

        validateAttorneyFee(fee) {
            if (fee.scope === "item" && !fee.user_event_item_id) return "Selecione o negócio do honorário.";
            if (!fee.procurator_name) return "Informe o procurador do honorário.";
            if (!this.onlyDigits(fee.procurator_registration)) return "Informe o CPF/CNPJ do procurador.";
            if (!fee.amount && fee.amount !== 0) return "Informe o valor do honorário.";
            if (!fee.type) return "Informe a classe do honorário.";

            return null;
        },

        buildAttorneyFeesPayload() {
            return this.dataset.attorneyFees.map((fee) => ({
                scope: fee.scope,
                user_event_item_id: fee.scope === "item" ? fee.user_event_item_id : null,
                procurator_user_id: fee.manual ? null : fee.procurator_user_id,
                procurator_name: fee.procurator_name,
                procurator_registration: this.onlyDigits(fee.procurator_registration),
                procurator_oab: fee.procurator_oab,
                amount: fee.amount,
                type: fee.type,
            }));
        },

        async loadProcurators() {
            this.dataset.procuratorsLoading = true;

            try {
                const result = await axios.get("/api/admin/procurators", {
                    params: {
                        page: 1,
                        limit: 100000,
                        search: {},
                    },
                });

                this.dataset.procurators = result.data.content.data || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.dataset.procuratorsLoading = false;
            }
        },

        async saveAttorneyFees() {
            const invalidMessage = this.dataset.attorneyFees
                .map((fee) => this.validateAttorneyFee(fee))
                .find(Boolean);

            if (invalidMessage) {
                this.$dialog.notify.error(invalidMessage, {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }

            this.dataset.attorneyFeesLoading = true;

            try {
                await axios.patch(`/api/admin/user-events/attorney-fees/${this.$route.params.id}`, {
                    attorney_fees: this.buildAttorneyFeesPayload(),
                });

                this.$dialog.notify.success("Honorários atualizados com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });

                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.dataset.attorneyFeesLoading = false;
            }
        },

        formatPortabilityRegistration() {
            this.portability.form.user_registration = this.formatRegistrationValue(
                this.portability.form.user_registration
            );
        },

        openPortabilityDialog() {
            this.portability.form = {
                user_name: "",
                user_registration: "",
                user_email: "",
            };
            this.dialogPortability = true;
        },

        closePortabilityDialog() {
            if (this.portability.loading) return;

            this.dialogPortability = false;
        },

        async savePortability() {
            const registration = this.onlyDigits(this.portability.form.user_registration);

            if (!this.portability.form.user_name || !registration) {
                this.$dialog.notify.error("Informe nome completo e CPF/CNPJ do credor de destino.", {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }

            this.portability.loading = true;

            try {
                await axios.patch(`/api/admin/user-events/portability/${this.$route.params.id}`, {
                    user_name: this.portability.form.user_name,
                    user_registration: registration,
                    user_email: this.portability.form.user_email,
                });

                this.$dialog.notify.success("Pedido portabilizado com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });

                this.dialogPortability = false;
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.portability.loading = false;
            }
        },

        openDialogDynamicText(targetField) {
            this.loadDynamicTexts();
            this.targetField = targetField;
            this.dialogDynamicText = true;
        },

        openLongReasonDialog() {
            this.dialogLongReason = true;
            this.refreshHelpDocumentPreview();
        },

        onFileSelected(file) {

            //this.dataset.data.reasonDocument = file;

            this.dataset.data.helpDocument = file;
            this.refreshHelpDocumentPreview();
        },

        refreshHelpDocumentPreview() {
            if (this.helpDocumentPreviewUrl && this.helpDocumentPreviewUrl.startsWith('blob:')) {
                URL.revokeObjectURL(this.helpDocumentPreviewUrl);
            }

            const file = this.dataset.data.helpDocument;

            if (file && file.type && file.type.startsWith('image/')) {
                this.helpDocumentPreviewUrl = URL.createObjectURL(file);
                return;
            }

            if (!file && this.isImageUrl(this.dataset.data.help_doc_url)) {
                this.helpDocumentPreviewUrl = this.dataset.data.help_doc_url;
                return;
            }

            this.helpDocumentPreviewUrl = null;
        },

        isImageUrl(url) {
            if (!url) return false;

            return /\.(png|jpe?g|gif|webp)(\?.*)?$/i.test(url);
        },

        notifyEditorError(message) {
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000,
            });
        },

        getContradictoryText(status) {
            switch (Number(status)) {
                case 1: return 'Aprovado';
                case 2: return 'Aprovado Parcialmente';
                case 3: return 'Rejeitado';
                default: return 'Pendente';
            }
        },

        getContradictoryColor(status) {
            switch (Number(status)) {
                case 1: return 'accent';   
                case 2: return '#80CBC4';  
                case 3: return 'error';    
                default: return 'grey';
            }
        },

        getContradictoryTone(status) {
            switch (Number(status)) {
                case 1: return 'success';
                case 2: return 'teal';
                case 3: return 'danger';
                default: return 'neutral';
            }
        },

        async fetchAnalysisStatus(itemId) {
            try {
                const response = await axios.get(`/api/user-events/item-analysis/${itemId}`);
                if (response.status === 200) {
                    return response.data.content.analysis_status;
                } else {
                    console.error("Erro ao buscar o analysis_status:", response);
                    return 1;
                }
            } catch (error) {
                console.error("Erro ao buscar o analysis_status:", error);
                return 1;
            }
        },

        async initializeAnalysisStatus() {
            this.statusLoading = true;

            try {
                for (let i = 0; i < this.dataset.data.items.length; i++) {
                    const item = this.dataset.data.items[i];

                    const status = await this.fetchAnalysisStatus(item.id);
                    this.$set(this.dataset.data.items[i], 'isChecked', status === 2);
                }

                this.updateProgress();
            } catch (error) {
                console.error("Erro ao inicializar status:", error);
            } finally {
                this.statusLoading = false;
            }
        },

        editPartialAmount(eventItem) {
            this.dataset.data.items.forEach(item => {
                item.isEditingPartialAmount = false;
            });
            eventItem.isEditingPartialAmount = true;
            this.editedPartialAmount = eventItem.partial_amount;
        },

        savePartialAmount(eventItem) {
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.isEditingPartialAmount = false;
        },

        cancelPartialAmount(eventItem) {
            this.editedPartialAmount = eventItem.partial_amount;
            eventItem.isEditingPartialAmount = false;
        },

        async saveReasons() {
            this.dataset.loading = true;

            const data = {
                smallReason: this.dataset.data.smallReason,
                reason: this.dataset.data.reason,
                status: this.dataset.data.status || 0,
                credit_exclusion: this.dataset.data.credit_exclusion ? 1 : 0,
                saveOnlyReasons: true,
            };

            try {
                await axios.patch(`/api/admin/user-events/action/${this.$route.params.id}`, data);
                
                this.$dialog.notify.success(`Informações atualizadas com sucesso!`, { 
                    position: "top-right", 
                    timeout: 2000 
                });
                

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        async saveComment() {
            const comment = (this.dataset.comment || "").trim();

            if (!comment) {
                this.$dialog.notify.error("Informe o comentário.", {
                    position: "top-right",
                    timeout: 2000
                });
                return;
            }

            if (comment.length > 1000) {
                this.$dialog.notify.error("Comentário muito longo. O limite é de 1000 caracteres.", {
                    position: "top-right",
                    timeout: 3000
                });
                return;
            }

            this.dataset.commentLoading = true;

            try {
                await axios.post(`/api/admin/user-events/comment/${this.$route.params.id}`, {
                    comment,
                    is_client: false
                });

                this.dataset.comment = "";
                await this.load();

                this.$dialog.notify.success("Comentário adicionado com sucesso!", {
                    position: "top-right",
                    timeout: 2000
                });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2000
                });
            } finally {
                this.dataset.commentLoading = false;
            }
        },

        reasonUpdateRemainingChars() {},

        reasonCheckMaxChars() {},


        getColorByStatus(status) {
            switch (status) {
                case 0: return 'warning';
                case 1: return 'accent';
                case 2: return 'error';
                case 3: return '#80CBC4';
                case 5: return '#7E55AB';
                default: return 'grey';
            }
        },

        // tom do ui-badge para o status do pedido/negocio
        getStatusTone(status) {
            switch (status) {
                case 0: return 'warning';
                case 1: return 'success';
                case 2: return 'danger';
                case 3: return 'teal';
                case 5: return 'purple';
                default: return 'neutral';
            }
        },

        getStatusBg(status) {
            switch (status) {
                case 0: return '#FFFBEB';
                case 1: return '#F0FDF4';
                case 2: return '#FEF2F2';
                case 3: return '#F0FDFA';
                case 5: return '#F3E8FF';
                default: return '#F3F4F6';
            }
        },

        getStatusTextColor(status) {
            switch (status) {
                case 0: return '#D97706';
                case 1: return '#16A34A';
                case 2: return '#DC2626';
                case 3: return '#0D9488';
                case 5: return '#7E55AB';
                default: return '#6B7280';
            }
        },

        getFinalStatus() {
            if (!this.dataset.data || !this.dataset.data.items) return 0;

            const hasPending = this.dataset.data.items.some(item => item.status === 0 || item.status === 5);

            if (hasPending) return 0;

            if (this.dataset.data.items.every(item => item.status === 1)) return 1;

            if (this.dataset.data.items.every(item => item.status === 2)) return 2;

            return 3;
        },

        getRequestDoc() {
            return JSON.parse(this.dataset.data.requested_doc || '[]')
        },

        getDocDescription(doc) {
            console.log('this.dataset.creditorEmailDocTypes ', this.dataset.creditorEmailDocTypes)
            return this.dataset.creditorEmailDocTypes.find((x) => x.id == doc) || "n/a"
        },

        getCategoryName(category_id) {
            const category = this.documentTypes.find(category => Number(category.id) === Number(category_id));
            return category ? category.name : 'Outros documentos';
        },

        getCreditorTypeName(typeId) {
            const types = this.dataset && Array.isArray(this.dataset.creditorTypes)
                ? this.dataset.creditorTypes
                : [];

            const type = types.find(item => item.id === typeId);

            return type ? type.name : 'N/A';
        },

        async statusReset(id) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja restaurar o pedido?',
                title: 'Restaurar',
                actions: {
                    false: 'Cancelar',
                    true: 'Restaurar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-events/restore/${this.$route.params.id}`, { status: 0 });

                this.$dialog.notify.info('Pedido restaurado com sucesso!', { position: "top-right", timeout: 2000 });

                this.goBack()

            } catch (error) {
                console.log("erro: ", error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateReview(status) {

            const actionText = status === 1 ? 'Aprovada' : status === 2 ? 'Rejeitada' : 'Atualizada';

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja marcar a revisão como <strong>${actionText}</strong>?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/review/update/${this.dataset.data.id}`, { status });

                this.$dialog.notify.info("Revisão atualizada com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                this.dataset.data.helpDocument = null;
                await this.loadData()
                this.refreshHelpDocumentPreview();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

         async changeStatusEventItem(eventItem, status) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja alterar o status do negócio <strong>#${eventItem.id}</strong> para <strong>${userEventUtil.userEventStatusText(status)}</strong>? `,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            try {
                this.dataset.loading = true;

                await axios.patch(`/api/admin/user-events/item/action/${eventItem.id}`, { status });

                this.$dialog.notify.info("Status atualizado com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error("Erro ao atualizar os dados.", {
                    position: "top-right",
                    timeout: 2000,
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        editItem(eventItem, index) {
            this.dataset.data.items.forEach(item => {
                item.isEditing = false;
            });
            this.partialAmountError = "";
            eventItem.isEditing = true;
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            this.editedReason = eventItem.reason;
            //this.editedCurrency = eventItem.currency;
            this.editedOrigin = eventItem.origin;

            // this.expandedPanel = index;
        },

        cancelEditItem(eventItem) {
            this.editedAmount = eventItem.amount;
            this.editedPartialAmount = eventItem.partial_amount;
            this.editedRequestNumber = eventItem.request_number;
            this.editedOrigin = eventItem.origin;
            eventItem.isEditing = false;
        },

        // O valor definido pela AJ pode ser maior ou menor que o indicado pelo credor.
        validatePartialAmount() {
            this.partialAmountError = "";
        },

        async saveEdit(eventItem) {
            if (this.editedAmount === null || this.editedAmount === undefined || this.editedAmount === '' || Number(this.editedAmount) < 0) {
                this.$dialog.notify.error("Informe o valor do pedido.", {
                    position: "top-right",
                    timeout: 2000,
                });
                return;
            }
            this.validatePartialAmount(eventItem);
            if (this.partialAmountError) {
                this.$dialog.notify.error("Corrija os erros antes de salvar.", {
                    position: "top-right",
                    timeout: 2000,
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do negócio?',
                title: 'Atualizar negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            eventItem.amount = this.editedAmount;
            eventItem.partial_amount = this.editedPartialAmount;
            eventItem.origin = this.editedOrigin;
            eventItem.reason = this.editedReason;
            eventItem.isEditing = false;

            this.editedAmount = null;
            this.editedPartialAmount = null;
            this.editedReason = null;
            this.editedOrigin = null;

            try {
                this.dataset.loading = true;

                const payload = {
                    type: eventItem.type,
                    amount: eventItem.amount,
                    partial_amount: eventItem.partial_amount,
                    //request_number: eventItem.request_number,
                    company_name: eventItem.company_name,
                    currency: eventItem.currency,
                    origin: eventItem.origin,
                    reason: eventItem.reason
                };

                await this.updateEventItem(eventItem.id, payload);

                this.$dialog.notify.info("Dados atualizados com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });
                eventItem.isEditing = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateEventItem(itemId, payload) {
            await axios.patch(`/api/admin/user-events/request/update/${itemId}`, payload);
        },

        resolveContradictoryDocs() {
            if (!this.dataset.data || !this.dataset.data.contradictory_docs) return [];

            let docs = JSON.parse(this.dataset.data.contradictory_docs || '[]');

            return !Array.isArray(docs) ? [] : docs

        },

        async copyToClipboard(data) {
            await navigator.clipboard.writeText(data);

            this.$dialog.notify.info(`Copiado para área de transferência!`, { position: "top-right", timeout: 3000 });
        },

        verifyIsRequestedDoc(doc) {
            if (!this.dataset.data || !this.dataset.data.requested_doc) return false;

            let requestedDocs = JSON.parse(this.dataset.data.requested_doc || '[]');

            if (!Array.isArray(requestedDocs)) return false;

            let result = false;

            for (let item of requestedDocs) {
                if (item.user_event_item_id) {
                    for (let docItem of item.docs) {
                        if (docItem.ref_id == doc.ref_id) {
                            result = true;
                            continue;
                        }
                    }
                }
            }

            return result;
        },


        closeDialogCreateBusiness() {

            this.dataset.newBusiness.origin = null,
            this.dataset.newBusiness.amount = null,
            this.dataset.newBusiness.currency = null,
            this.dataset.newBusiness.company_name = null,
            this.dataset.newBusiness.request_number = null,
            this.dataset.newBusiness.type = null,
            this.dataset.newBusiness.ref_date = null,
            this.dataset.newBusiness.docs = [],
            this.dataset.newBusiness.observation = null,
            this.dialogCreateBusiness = false;
        },

        async saveNewBusiness() {

            if (!this.$refs.newBusinessForm.validate()) {
                this.$dialog.notify.error("Verifique se todos os campos obrigatórios foram preenchidos!", {
                    position: "top-right",
                    timeout: 5000,
                });

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja adicionar o negócio?',
                title: 'Adicionar negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Adicionar'
                }
            })

            if (!proceedAction) return;

            const payload = this.newBusinessPayload();

            this.dataset.loadingSave = true;

            try {

                await axios.post(`/api/admin/user-events/event-item-create`, payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.$dialog.notify.success("Negócio adicionado com sucesso!", {
                    position: "top-right",
                    timeout: 5000,
                });

            } catch (error) {
                this.$dialog.notify.error("Erro ao adicionar o negócio!", {
                    position: "top-right",
                    timeout: 5000,
                });
            } finally {

                this.dataset.loadingSave = false;
                this.closeDialogCreateBusiness();
                this.loadData();
            }
        },

        newBusinessPayload() {

            const formData = new FormData();
            formData.append("event_id", this.dataset.data.id);
            formData.append("type", this.dataset.newBusiness.type);
            formData.append("amount", this.dataset.newBusiness.amount);
            formData.append("currency", this.dataset.newBusiness.currency);
            formData.append("origin", this.dataset.newBusiness.origin);
            formData.append("company_name", this.dataset.newBusiness.company_name);
            formData.append("ref_date", this.dataset.newBusiness.ref_date);
            formData.append("request_number", this.dataset.newBusiness.request_number);
            formData.append("observation", this.dataset.newBusiness.observation);

            if (this.dataset.newBusiness.docs && Array.isArray(this.dataset.newBusiness.docs)) {
                this.dataset.newBusiness.docs.forEach((file) => {
                    formData.append("docs", file);
                });
            }

            return formData;

        },

        filesRequired() {
            return this.dataset.newBusiness.docs.length > 0 || "Você deve adicionar pelo menos um documento!";
        },

        addFiles(files) {
            this.dataset.newBusiness.docs.push(...files);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        triggerFileInput() {
            const fileInput = this.$refs.fileInput.$el.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.click();
            }
        },

        removeFile(index) {
            this.dataset.newBusiness.docs.splice(index, 1);

            this.$refs.newBusinessForm && this.$refs.newBusinessForm.validate();
        },

        async sendSelectedList() {

            const payload = this.requestedDocsPayload();

            if (!this.selectedRequestDocs || this.selectedRequestDocs.length === 0) {

                this.$dialog.notify.error(`Nenhum documento seleciondo!`, { position: "top-right", timeout: 3000 });

                return
            }

            if (this.selectedRequestDocs.includes(3)) {
                const hasBusinessDocs = Object.values(this.selectedBusinessDocs).some(
                    businessDoc => businessDoc.docs && businessDoc.docs.length > 0
                );

                if (!hasBusinessDocs) {
                    this.$dialog.notify.error(
                        `Documentos Comprobatórios está selecionado, mas nenhum documento dentro do(s) negócio(s) foi marcado!`,
                        { position: "top-right", timeout: 5000 }
                    );
                    return;
                }
            }

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/creditor-doc-request/${this.$route.params.id}`, { docList: payload });

                await this.loadData()

                this.$dialog.notify.info("Solicitação enviada com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.dataset.loading = false;
                this.selectedRequestDocs = [];
                this.dataset.analysis_return = false;
                this.handleDocumentSelection();
                this.dialogRequestDoc = false;
            }

        },

        requestedDocsPayload() {
            const payload = [];

            for (const [itemId, { docs, origin, amount, customName }] of Object.entries(this.selectedBusinessDocs)) {
                if (docs.length > 0) {
                    const updatedDocs = docs.map(docId => {
                        const docPayload = {
                            id: docId,
                            uploaded: false,
                        };

                        if (docId === 50 && customName) {
                            docPayload.customName = customName;
                        }

                        return docPayload;
                    });

                    payload.push({
                        user_event_item_id: parseInt(itemId, 10),
                        docs: updatedDocs,
                        origin: origin,
                        amount: amount,
                    });
                }
            }

            if (this.selectedRequestDocs.length > 0) {
                const updatedDocs = this.selectedRequestDocs.map(docId => ({
                    id: docId,
                    uploaded: false,
                }));

                payload.push({
                    user_event_id: this.dataset.data.id || null,
                    analysis_return: this.dataset.analysis_return,
                    docs: updatedDocs,
                });
            }

            return payload;
        },

        switchChange(value) {
           // console.log("🔄 Switch alterado para:", value);

            this.dataset.analysis_return = value;
        },

        closeDialogRequestDoc() {
            this.selectedRequestDocs = [];
            this.handleDocumentSelection();
            this.dialogRequestDoc = false;
        },

        handleDocumentSelection(docId, itemId) {

            //console.log("Entrou em handleDocumentSelection", docId, itemId)

            if (!this.selectedRequestDocs.includes(3)) {
                for (const key in this.selectedBusinessDocs) {
                    if (this.selectedBusinessDocs[key].docs.length > 0) {
                        this.selectedBusinessDocs[key].docs = [];
                    }
                }
            }

            if (docId === 50) {

                if (!this.selectedRequestDocs.includes(50) && !itemId) {
                    this.customDocumentName = "";
                }

                if (itemId && !this.selectedBusinessDocs[itemId].docs.includes(50)) {
                    this.selectedBusinessDocs[itemId].customName = "";
                }
            }
        },

        async updateHelpDoc() {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o documento de apoio?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            if (!this.dataset.data.helpDocument) {
                this.$dialog.notify.warning('Nenhum documento selecionado para enviar.', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            try {
                this.dataset.loading = true;

                const formData = new FormData();

                formData.append("help", this.dataset.data.helpDocument)

                await axios.patch(`/api/admin/user-events/help-doc/${this.dataset.data.id}`, formData);

                this.$dialog.notify.info("Documento atualizado com sucesso!", {
                    position: "top-right",
                    timeout: 2000,
                });

                await this.loadData()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        openEditDocumentsDialog(eventItem) {
            this.editDocuments = {
                item: eventItem,
                files: [],
                removeDocIds: [],
                docType: 3,
                loading: false,
            };

            this.dialogEditDocuments = true;
        },

        closeEditDocumentsDialog() {
            if (this.editDocuments.loading) return;

            this.dialogEditDocuments = false;
            this.editDocuments = {
                item: null,
                files: [],
                removeDocIds: [],
                docType: 3,
                loading: false,
            };
        },

        isDocumentMarkedForRemoval(docId) {
            return this.editDocuments.removeDocIds.includes(docId);
        },

        toggleRemoveDocument(docId) {
            if (this.isDocumentMarkedForRemoval(docId)) {
                this.editDocuments.removeDocIds = this.editDocuments.removeDocIds.filter(id => id !== docId);
                return;
            }

            this.editDocuments.removeDocIds.push(docId);
        },

        triggerEditDocumentFileInput() {
            const input = this.$refs.editDocumentFileInput && this.$refs.editDocumentFileInput.$el
                ? this.$refs.editDocumentFileInput.$el.querySelector('input[type="file"]')
                : null;

            if (input) input.click();
        },

        addEditDocumentFiles(files) {
            const selectedFiles = Array.isArray(files) ? files : (files ? [files] : []);
            this.editDocuments.files.push(...selectedFiles);
        },

        removeEditDocumentFile(index) {
            this.editDocuments.files.splice(index, 1);
        },

        async saveEventItemDocuments() {
            if (!this.editDocuments.item) return;

            if (!this.editDocuments.files.length && !this.editDocuments.removeDocIds.length) {
                this.$dialog.notify.warning("Nenhuma alteração foi informada.", {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }

            const currentDocsCount = this.editDocuments.item.docs ? this.editDocuments.item.docs.length : 0;
            const finalDocsCount = currentDocsCount - this.editDocuments.removeDocIds.length + this.editDocuments.files.length;

            if (finalDocsCount <= 0) {
                this.$dialog.notify.error("O negócio precisa manter ao menos um documento.", {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os documentos deste negócio?',
                title: 'Editar documentos',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            });

            if (!proceedAction) return;

            const payload = new FormData();
            payload.append("doc_type", this.editDocuments.docType || 3);
            payload.append("remove_doc_ids", JSON.stringify(this.editDocuments.removeDocIds));

            this.editDocuments.loading = true;

            try {
                // Arquivos grandes ou ZIP vao antes, em partes; os demais seguem no multipart.
                const uploadedFiles = [];
                for (const file of this.editDocuments.files) {
                    const fileError = validateDocumentFile(file);
                    if (fileError) throw new Error(fileError);

                    if (needsChunkedUpload(file)) {
                        this.editDocuments.uploadProgress = { name: file.name, percent: 0 };
                        const uploaded = await chunkedUpload(file, {
                            onProgress: (percent) => { this.editDocuments.uploadProgress = { name: file.name, percent }; },
                        });
                        uploadedFiles.push({ key: uploaded.key, name: uploaded.name, size: uploaded.size, type: this.editDocuments.docType || 3 });
                    } else {
                        payload.append("docs", file);
                    }
                }
                this.editDocuments.uploadProgress = null;
                if (uploadedFiles.length) payload.append("uploaded_files", JSON.stringify(uploadedFiles));

                await axios.patch(`/api/admin/user-events/item-docs/${this.editDocuments.item.id}`, payload, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                this.$dialog.notify.success("Documentos atualizados com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });

                this.editDocuments.loading = false;
                this.editDocuments.uploadProgress = null;
                this.closeEditDocumentsDialog();
                await this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                });
            } finally {
                this.editDocuments.loading = false;
                this.editDocuments.uploadProgress = null;
            }
        },

        
        getEventItemsByCategory(eventItem) {
            const categories = {};

            eventItem.docs.forEach(docItem => {
                const category_id = docItem.doc.type;

                if (!categories[category_id]) {
                    categories[category_id] = {
                        id: category_id,
                        name: this.getCategoryName(category_id),
                        docs: []
                    };
                }

                categories[category_id].docs.push({
                    id: docItem.id,
                    name: docItem.doc.name,
                    file_url: docItem.doc.file_url
                });
            });

            return Object.values(categories);
        },


        openDoc(doc) {
            window.open(doc, '_blank');
            // this.selectedDoc = doc;
            // this.dialogViewDoc = true;
        },

        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        updateContraditory(value) {
            this.dataset.data.contradictory_deadline_at = value;
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            // Prazo e data civil de Brasilia: usa o dia gravado, sem conversao de fuso.
            return String(date).slice(0, 10);
        },

        // Carimbo do servidor (UTC): exibe em Brasilia.
        formatDateTime(date) {
            if (!date || date === "0000-00-00 00:00:00") return "N/A";
            return this.$options.filters.defaultDate(date, "DD/MM/YYYY HH:mm");
        },

        commentAuthor(comment) {
            return comment && comment.admin && comment.admin.name
                ? comment.admin.name
                : "Administrador";
        },

        getMessageByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `Usuário acessou o sistema no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'accept-value':
                    result = `Usuário aceitou o crédito no valor de R$ ${this.dataset.data.requested_value} no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'verify-account':
                    result = `Usuário verificou a conta no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'register-user':
                    result = `Usuário criou a conta no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                case 'create-event':
                    result = `Usuário registrou uma divergência no dia ${this.$options.filters.defaultDate(item.created_at, 'DD/MM/YYYY HH:mm')}`;
                    break;

                default:
                    break;
            }

            return result;
        },

        getTitleByTypeEvent(item) {
            let result = '';

            switch (item.type) {
                case 'login-account':
                    result = `acesso`;
                    break;

                case 'accept-value':
                    result = `CRÉDITO`;
                    break;

                case 'verify-account':
                    result = `verificação`;
                    break;

                case 'register-user':
                    result = `cadastro`;
                    break;

                case 'create-event':
                    result = `divergência`;
                    break;

                default:
                    break;
            }

            return result;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
            //await this.loadLogs();

            //await this.loadCreditorReports();

            this.updateProgress();

            this.loadClients();
            this.loadProcurators();

            this.reasonUpdateRemainingChars();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            //this.page.title = `Detalhes da ${this.dataset.data.user.uuid_ref ? 'divergência' : 'habilitação'}`;
            this.page.title = `Detalhes do pedido`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Divergência",
                disabled: false,
                to: "/divergencias",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                //text: `Detalhes da ${this.dataset.data.user.uuid_ref ? 'divergência' : 'habilitação'}`,
                text: `Detalhes do pedido`,
                disabled: true,
                exact: true,
            });
        },

        // Insere o texto automatico onde esta o cursor do editor do campo; sem
        // editor montado, acrescenta no fim (comportamento anterior).
        insertIntoEditor(refName, html, append) {
            const ref = Array.isArray(this.$refs[refName]) ? this.$refs[refName][0] : this.$refs[refName];
            if (ref && ref.insertHtml) ref.insertHtml(html || '');
            else append();
        },

        selectDynamicText(item) {
            if (this.targetField === 'smallReason') {
                this.insertIntoEditor('smallReasonEditor', item.small_description, () => { this.dataset.data.smallReason = (this.dataset.data.smallReason || '') + item.small_description; });
            } else if (this.targetField === 'editedReason') {
                this.insertIntoEditor('itemReasonEditor', item.description, () => { this.editedReason = (this.editedReason || '') + item.description; });
            } else if (this.targetField === 'reason') {
                const ref = this.dialogLongReason ? 'reasonEditorDialog' : 'reasonEditor';
                this.insertIntoEditor(ref, item.description, () => { this.dataset.data.reason = (this.dataset.data.reason || '') + item.description; });
            }

            this.dialogDynamicText = false;

            this.reasonUpdateRemainingChars();
        },

        updateProgress() {
            const totalItems = this.dataset.data.items.length || 0;

            //console.log("totalItems: ", totalItems)

            const completedItems = this.dataset.data.items.filter(item => item.status !== 0 && item.status !== 4 && item.status !== 5).length || 0;
            this.progress = Math.round((completedItems / totalItems) * 100);
        },

        toggleCheckbox(eventItem) {
            eventItem.isEditing = false;
            this.expandedPanel = null;

            // Atualize o progresso ao mudar o status
            this.updateProgress();

            const newStatus = eventItem.isChecked ? 2 : 1;

            // Chamar o backend para atualizar o analysis_status
            this.updateBackend(eventItem.id, newStatus);
        },

        async updateBackend(itemId, analysisStatus) {
            try {
                const response = await axios.patch(`/api/user-events/item-analysis/${itemId}`, {
                    analysis_status: Number(analysisStatus)
                });

                if (response.status === 200) {
                    //console.log("Analysis status atualizado com sucesso.");
                }
            } catch (error) {
                console.error("Erro ao atualizar o analysis status:", error);
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async updateStatus() {
            
            // 1. Verifica o status calculado com base nos itens da lista
            const computedStatus = this.getFinalStatus();

            // Se o status calculado for 0, significa que ainda tem itens pendentes ou não avaliados
            if (computedStatus === 0) {
                this.$dialog.notify.warning("O pedido precisa ter um status de Aprovado ou Rejeitado (avalie todos os itens) antes de confirmar.", {
                    position: "top-right",
                    timeout: 5000
                });
                return;
            }

            // 2. Validações de Texto (Obrigatório ter motivo ao confirmar)
            if (!this.dataset.data.smallReason || this.stripHtml(this.dataset.data.smallReason).length === 0) {
                this.$dialog.notify.error("O campo 'Texto curto' é obrigatório.", { position: "top-right", timeout: 3000 });
                return;
            }

            if (!this.dataset.data.reason || this.stripHtml(this.dataset.data.reason).length === 0) {
                this.$dialog.notify.error("O campo 'Texto longo' é obrigatório.", { position: "top-right", timeout: 3000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja finalizar o pedido com status <strong>${this.getStatusName(computedStatus)}</strong>?`,
                title: `Confirmação`,
                actions: { false: 'Cancelar', true: 'Confirmar' }
            });

            if (!proceedAction) return;

            this.dataset.loading = true;

            const data = {
                smallReason: this.dataset.data.smallReason,
                reason: this.dataset.data.reason,
                status: computedStatus,
                credit_exclusion: this.dataset.data.credit_exclusion ? 1 : 0
            };

            if (computedStatus === 3) {
                data.eventItems = this.dataset.data.items.map(item => ({
                    id: item.id,
                    amount: item.partial_amount !== null && item.partial_amount !== undefined
                        ? item.partial_amount
                        : item.amount
                }));
            }

            try {
                await axios.patch(`/api/admin/user-events/action/${this.$route.params.id}`, data);
                
                this.$dialog.notify.info(`Pedido finalizado com sucesso!`, { position: "top-right", timeout: 2000 });
                
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async createReview() {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar para revisão?`,
                title: `Confirmação`,
                actions: {
                    false: 'Cancelar',
                    true: 'Confirmar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                await axios.patch(`/api/admin/user-events/review/create/${this.$route.params.id}`)

                this.$dialog.notify.info(`Pedido enviado para revisão com sucesso!`, { position: "top-right", timeout: 2000 });

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        getStatusName(statusId) {
            const status = this.dataset.eventStatus.find(x => x.id === statusId);
            return status ? status.name : 'Desconhecido';
        },

        openRequestDoc() {

            this.dialogRequestDoc = true;
        },

        openCreateBusinessModal() {

            this.dialogCreateBusiness = true;
        },


        // async updateStatus(approve = 'reject') {

        //     if (approve === 'partial' && (!this.dataset.partialItems.length)) {
        //         this.$dialog.notify.error("Informe os novos valores para continuar!", { position: "top-right", timeout: 2000 });
        //         return;
        //     }

        //     if (!this.dataset.data.smallReason || !this.dataset.data.reason) {
        //         this.$dialog.notify.error("Motivo é obrigatório", { position: "top-right", timeout: 2000 });
        //         return;
        //     }

        //     const proceedAction = await this.$dialog.confirm({
        //         text: `Deseja ${approve === 'approve' ? 'aprovar' : (approve === 'reject' ? 'rejeitar' : 'aprovar parcialmente')} a divergência?`,
        //         title: `${approve === 'approve' ? 'Aprovar' : (approve === 'reject' ? 'Rejeitar' : 'Aprovar parcialmente')} divergência`,
        //         actions: {
        //             false: 'Cancelar',
        //             true: approve === 'approve' ? 'Aprovar' : (approve === 'reject' ? 'Rejeitar' : 'Aprovar parcialmente')
        //         }
        //     })

        //     if (!proceedAction) return;

        //     this.dataForm.addLoading = true;

        //     // const data = {
        //     //     smallReason: this.dataset.data.smallReason,
        //     //     reason: this.dataset.data.reason,
        //     //     reasonDocument: this.dataset.data.reasonDocument,
        //     //     status: approve === 'approve' ? 1 : (approve === 'reject' ? 2 : 3)
        //     // }

        //     // if (approve === 'partial') {
        //     //     data.eventItems = this.dataset.partialItems;
        //     // }

        //     const formData = new FormData();
        //     formData.append('smallReason', this.dataset.data.smallReason);
        //     formData.append('reason', this.dataset.data.reason);
        //     formData.append('status', approve === 'approve' ? 1 : (approve === 'reject' ? 2 : 3));

        //     if (this.dataset.data.reasonDocument) {
        //         formData.append('reasonDocument', this.dataset.data.reasonDocument);
        //     }

        //     if (approve === 'partial') {
        //         formData.append('eventItems', JSON.stringify(this.dataset.partialItems));
        //     }

        //     try {
        //         const response = await axios.patch(`/api/admin/user-events/action/${this.$route.params.id}`, formData)

        //         this.$dialog.notify.info(`Divergência ${approve === 'approve' ? 'aprovada' :
        //             (approve === 'reject' ? 'rejeitada' : 'aprovada parcialmente')} com sucesso!`, { position: "top-right", timeout: 2000 });

        //         this.goBack();

        //     } catch (error) {
        //         this.$dialog.notify.error(this.$codes(error), {
        //             position: 'top-right',
        //             timeout: 2000
        //         })
        //     } finally {
        //         this.dataForm.addLoading = false;
        //     }
        // },

        async updateContradictoryDeadline() {

            if (!this.dataset.data.contradictory_deadline_at) {
                this.$dialog.notify.error("O campo Prazo é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar o prazo para contraditórios?`,
                title: `Atualizar divergência`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/contradictory-deadline/${this.$route.params.id}`, { contradictory_deadline_at: this.dataset.data.contradictory_deadline_at })

                // A recuperanda recebe e-mail quando o prazo e aberto ou retificado.
                const notified = response.data && response.data.content && Array.isArray(response.data.content.notified) ? response.data.content.notified : [];
                this.$dialog.notify.info(
                    `Prazo atualizado com sucesso!${notified.length ? ` Recuperanda notificada por e-mail (${notified.join(', ')}).` : ' Nenhum e-mail de recuperanda cadastrado para o caso.'}`,
                    { position: "top-right", timeout: 5000 }
                );

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        openItemCreditDialog(eventItem, credit = null) {
            this.itemCredit = {
                dialog: true,
                saving: false,
                id: credit ? credit.id : null,
                itemId: eventItem.id,
                type: credit ? credit.type : null,
                amount: credit ? Number(credit.amount) : null,
                currency: credit ? credit.currency : (eventItem.currency || 1),
                description: credit ? (credit.description || "") : "",
            };
        },

        async saveItemCredit() {
            const credit = this.itemCredit;

            if (!credit.type) {
                this.$dialog.notify.error("Selecione a classe.", { position: "top-right", timeout: 3000 });
                return;
            }

            if (credit.amount === null || credit.amount === undefined || credit.amount === "") {
                this.$dialog.notify.error("Informe o valor.", { position: "top-right", timeout: 3000 });
                return;
            }

            credit.saving = true;

            try {
                const payload = {
                    type: credit.type,
                    amount: credit.amount,
                    currency: credit.currency,
                    description: credit.description || undefined,
                };

                if (credit.id) {
                    await axios.patch(`/api/admin/user-event-item-credits/${credit.id}`, payload);
                } else {
                    await axios.post(`/api/admin/user-event-items/${credit.itemId}/credits`, payload);
                }

                this.$dialog.notify.success(
                    credit.id ? "Crédito adicional atualizado." : "Crédito adicional incluído.",
                    { position: "top-right", timeout: 3000 }
                );

                credit.dialog = false;
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao salvar o crédito adicional.", { position: "top-right", timeout: 3000 });
            } finally {
                credit.saving = false;
            }
        },

        async confirmItemCreditDeletion(eventItem, credit) {
            const proceed = await this.$dialog.confirm({
                title: "Excluir crédito adicional",
                text: `Deseja excluir o crédito de <strong>${this.getCreditorTypeName(credit.type)}</strong>?`,
                actions: { false: "Cancelar", true: "Excluir" }
            });

            if (!proceed) return;

            try {
                await axios.delete(`/api/admin/user-event-item-credits/${credit.id}`);

                this.$dialog.notify.success("Crédito adicional excluído.", { position: "top-right", timeout: 3000 });
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao excluir o crédito adicional.", { position: "top-right", timeout: 3000 });
            }
        },

        async loadCreditorClasses() {
            const client = this.dataset.data && this.dataset.data.client ? this.dataset.data.client : null;
            const clientId = client && client.id ? client.id : null;

            const active = await creditorClassUtil.listByClient(clientId);
            const activeIds = active.map((item) => Number(item.id));

            // Um item ja gravado pode estar numa classe posteriormente oculta.
            // Ela entra na lista para que o valor continue legivel e nao seja
            // perdido ao salvar o registro.
            const usedIds = (this.dataset.data && Array.isArray(this.dataset.data.items)
                ? this.dataset.data.items
                : []
            ).map((item) => Number(item.type)).filter(Boolean);

            const missing = usedIds.filter((id) => !activeIds.includes(id));

            if (!missing.length) {
                this.dataset.creditorTypes = active;
                return;
            }

            const all = await creditorClassUtil.listLabels(clientId);

            this.dataset.creditorTypes = [
                ...active,
                ...all.filter((item) => missing.includes(Number(item.id))
                    && !activeIds.includes(Number(item.id))),
            ];
        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/user-events/find/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.data = {
                    ...data,
                    // Arquivo de apoio escolhido e ainda nao salvo (reativo para o ui-file-drop).
                    helpDocument: null,
                    items: data.items.map(item => ({
                        ...item,
                        isEditing: false,
                        isChanged: false, 
                    })),
                };

                //console.log("data: ", this.dataset.data)

                this.dataset.data.smallReason = data.small_reason || ""
                this.dataset.data.reason = data.reason || ""
                this.dataset.attorneyFees = this.normalizeAttorneyFees(data.attorneyFees || data.attorney_fees || []);

                const registration = this.dataset.data.user.registration;

                if (registration) {
                    this.dataset.data.user.registration = this.formatRegistrationValue(registration);
                }

                await this.loadCreditorClasses();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadDynamicTexts() {

            try {
                const result = await axios.get(`/api/admin/dynamic-texts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.dynamicTexts = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                description: this.dataset.data.description,
                client: this.dataset.data.client,
                unit: this.dataset.data.unit,
                associations: this.normalizeAssociations(),
                credential: {
                    username: this.dataset.data.email,
                    password: this.dataset.data.password,
                },
                roles: this.dataset.data.roles

            }

            return data;
        },

        

        partialAcceptModal(item) {
            this.dataset.selectedItem = item;
            this.dialogPartialAccept = true;
        },

        savePartialValue() {

            if (!this.dataset.selectedItem.partialAmount) {

                this.$dialog.notify.error('Valor digitado é inválido!', { position: "top-right", timeout: 2000 });

                return;
            }

            const index = this.dataset.partialItems.findIndex((x) => x.id == this.dataset.selectedItem.id);

            if (index == -1) {
                this.dataset.partialItems.push({ id: this.dataset.selectedItem.id, amount: this.dataset.selectedItem.partialAmount })
            } else {
                this.dataset.partialItems[index] = { id: this.dataset.selectedItem.id, amount: this.dataset.selectedItem.partialAmount };
            }

            this.dialogPartialAccept = false;

        },

        
        onAutocompleteChange(eventIndex) {
            this.$set(this.dataset.data.items[eventIndex], 'isChanged', true);
        },


        async updateClassType(eventItem, eventIndex) {

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja atualizar a classe do negócio?`,
                title: `Atualizar classe`,
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            const id = eventItem.id
            const type = eventItem.type

            this.dataset.loading = true;

            try {
                const response = await axios.patch(`/api/admin/user-events/class-type-change/${id}`, { type: type })

                this.$dialog.notify.info(`Classe atualizada com sucesso!`, { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.dataset.loading = false;
            }
            
            this.$set(this.dataset.data.items[eventIndex], 'isChanged', false);
        },
    },

};

</script>
  
<style lang="scss">
.late-filing-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 16px;
}

.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.attorney-fee-row {
    border: 1px solid #edf0f7;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px;
}

.centered {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 15px;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

// Area de trabalho do motivo (dialogo em tela cheia)
.reason-workspace {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #fff;
}

.reason-workspace__bar {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 60px;
    padding: 0 12px 0 24px;
    border-bottom: 1px solid #e2e8f0;
    flex-shrink: 0;
}

.reason-workspace__title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    line-height: 1.2;
    color: #0f172a;
}

.reason-workspace__subtitle {
    font-size: 12.5px;
    color: #64748b;
}

.reason-workspace__spacer {
    flex: 1 1 auto;
}

.reason-workspace__toggle--on.v-btn {
    background-color: #f3f5fb !important;
    border-color: #27306b !important;
}

.reason-workspace__body {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
}

.reason-workspace__editor.doc-editor {
    flex: 1 1 auto;
    min-width: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none !important;

    .doc-editor__canvas {
        max-height: none !important;
    }
}

.reason-workspace__panel {
    width: 380px;
    flex-shrink: 0;
    padding: 20px;
    border-left: 1px solid #e2e8f0;
    overflow-y: auto;
    background: #fff;
}

.reason-workspace__panel-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 16px;
}

@media (max-width: 960px) {
    .reason-workspace__body {
        flex-direction: column;
    }

    .reason-workspace__panel {
        width: auto;
        border-left: 0;
        border-top: 1px solid #e2e8f0;
    }
}

.edit-doc-card {
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.edit-doc-card--remove {
    border-color: var(--v-error-base) !important;
    background-color: #fff5f5;
}








.event-comments-list {
    display: grid;
    gap: 12px;
}

.event-comment-item {
    padding: 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
}

.event-comment-text {
    white-space: pre-wrap;
    color: #374151;
}

.icon-container {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
}

.image-resizer {
    display: inline-flex;
    position: relative;
    flex-grow: 0;
}

.image-resizer .resize-trigger {
    position: absolute;
    right: -6px;
    bottom: -9px;
    opacity: 0;
    transition: opacity .3s ease;
    color: #3259a5;
}

.image-resizer:hover .resize-trigger {
    opacity: 1;
}

.document-container {
  position: relative;
  width: 70%;
  display: flex;
  justify-content: flex-start; 
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%; 
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
}

.document-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.caption-text {
  font-weight: 600;
  font-size: 14px;
  color: var(--v-primary-base);
  text-align: center;
}



.contradictory-doc-name {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: none;
}
</style>
